function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 652.58,
  y1: 850.47,
  x2: 652.58,
  y2: 265.49,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 1069.38,
  y1: 751.23,
  x2: 1069.38,
  y2: 686.58,
  xlinkHref: "#a"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.46 423.83c17.58 72.21 54.78 134.64 113.58 164.88 122.19 62.88 397.76 30.45 603.43-6.77 106.36-19.26 199.88-72.36 267.81-147.17zM1104.98 83.95H992.14a9.38 9.38 0 1 1 0-18.75h19.5a9.38 9.38 0 1 1 0-18.75h-13.93a9.38 9.38 0 1 1 0-18.75h58.9c-13.08-5.84-28.3-10-46-12.17-160.6-19.83-217.94-6.71-238.17 6.78-24.95 16.64-52.8 28.88-82.54 34.78-99.04 19.65-284.34 43.29-452.34-7.57-83.45-25.27-145.5 17.44-182.69 88.83h1069.69c-1.4-20.75-5.58-39.91-13.26-56.68a9.87 9.87 0 0 1-6.32 2.28zM702.75 311.73l-1.47-.08-15.36-.87-147.16-8.31-15.9-.9-234.3-13.16-65.67-3.7-10.4-.58-9.23-.52-186.37-10.49a458.93 458.93 0 0 0 4.38 126l156.79 5.5 12.43.45 2.2.07 74.38 2.62 4 .14 8.58.3 75 2.64 10.28.36 35.86 1.27h.67l5.27.19 17.95.63 15.75.55 30 1.06h.63l2.68.09 2.83.11h.62l47.82 1.67 13.4.48h.56l6.45.23h1.68l5.67.21 17.31.61 6.5.23 8.35.29h.31l11.46.4 33.21 1.25 9.12.31h1l44.18 1.56 25.65.9 31.98 1.23 5.12.17 8.27.29 30.06 1.06 226.75 8a446.33 446.33 0 0 0 68.83-100.92zm-426.34 70a9.94 9.94 0 0 1-6.5-2.4 9.89 9.89 0 0 1-2.06-2.5 9.1 9.1 0 0 1-1.19-4.47 9 9 0 0 1 1.61-5.13 10.49 10.49 0 0 1 1.08-1.3 9.91 9.91 0 0 1 7.06-2.92h19.5a9.38 9.38 0 1 1 0-18.75h-13.93a9.1 9.1 0 0 1-.91 0 9.37 9.37 0 0 1 .91-18.71h112.84a9.38 9.38 0 1 1 0 18.75h13.93a9.38 9.38 0 1 1 0 18.75h-19.5a9.38 9.38 0 1 1 0 18.75zM1124.62 139.01l-778.36 18.2-85.55 2-217.77 5.1c-13.17 32.51-21.89 69.26-25.9 107.36h1088.63a430.57 430.57 0 0 0 15.71-68.44c3.24-22.39 4.55-44.05 3.24-64.22zm-888 82.87h-19.5a9.59 9.59 0 0 1 9.75 9.37v.57a9.32 9.32 0 0 1-4.32 7.23 10 10 0 0 1-5.41 1.58H104.3a9.38 9.38 0 1 1 0-18.75h19.51a9.38 9.38 0 1 1 0-18.75h-13.93a9.38 9.38 0 1 1 0-18.75h112.84a9.38 9.38 0 1 1 0 18.75h13.93a10 10 0 0 1 4.63 1.14 9.36 9.36 0 0 1 5.13 8.24 9.61 9.61 0 0 1-9.76 9.37z",
  fill: "#00c7fa",
  opacity: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M604.98 583.09s28.58-67.62 81.87-92.73c22.37-10.53 40.87-27.4 52.21-48.73a181.94 181.94 0 0 0 13.09-31.6",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M785.64 394.02c-5.55 6.72-34.32 16.52-34.32 16.52s3.47-29.14 9-35.86a16.62 16.62 0 0 1 22.72-2.49 15.13 15.13 0 0 1 2.6 21.83zM775.77 447.21c-8.46 2.74-38.14-4.06-38.14-4.06s19.38-22.66 27.84-25.39 17.63 1.64 20.48 9.77a15.41 15.41 0 0 1-10.18 19.68zM722.26 510.09c-8.74-1.75-30.8-22-30.8-22s28.64-10.15 37.38-8.4 14.35 10 12.54 18.37-10.38 13.77-19.12 12.03zM670.63 548.89c-8.92-.3-34.23-16.7-34.23-16.7s26.44-14.66 35.36-14.35 15.9 7.49 15.59 16.07-7.79 15.28-16.72 14.98zM709.99 424.14c1.14 8.51 20.47 31.21 20.47 31.21s12.73-26.66 11.59-35.18-9.24-14.52-18.09-13.42-15.11 8.88-13.97 17.39zM650.2 470.26c3.74 7.79 29.25 23.89 29.25 23.89s3.85-29.1.11-36.9a16.43 16.43 0 0 0-21.44-7.6 15.29 15.29 0 0 0-7.92 20.61zM598.49 522.75c2.31 8.29 24.63 28.3 24.63 28.3s8.91-28.06 6.59-36.35-11.17-13.2-19.79-11a15.48 15.48 0 0 0-11.43 19.05z",
  fill: "#00c7fa"
}), /*#__PURE__*/React.createElement("path", {
  d: "M785.64 394.02c-5.55 6.72-34.32 16.52-34.32 16.52s3.47-29.14 9-35.86a16.62 16.62 0 0 1 22.72-2.49 15.13 15.13 0 0 1 2.6 21.83zM775.77 447.21c-8.46 2.74-38.14-4.06-38.14-4.06s19.38-22.66 27.84-25.39 17.63 1.64 20.48 9.77a15.41 15.41 0 0 1-10.18 19.68zM722.26 510.09c-8.74-1.75-30.8-22-30.8-22s28.64-10.15 37.38-8.4 14.35 10 12.54 18.37-10.38 13.77-19.12 12.03zM670.63 548.89c-8.92-.3-34.23-16.7-34.23-16.7s26.44-14.66 35.36-14.35 15.9 7.49 15.59 16.07-7.79 15.28-16.72 14.98zM709.99 424.14c1.14 8.51 20.47 31.21 20.47 31.21s12.73-26.66 11.59-35.18-9.24-14.52-18.09-13.42-15.11 8.88-13.97 17.39zM650.2 470.26c3.74 7.79 29.25 23.89 29.25 23.89s3.85-29.1.11-36.9a16.43 16.43 0 0 0-21.44-7.6 15.29 15.29 0 0 0-7.92 20.61zM598.49 522.75c2.31 8.29 24.63 28.3 24.63 28.3s8.91-28.06 6.59-36.35-11.17-13.2-19.79-11a15.48 15.48 0 0 0-11.43 19.05z",
  opacity: 0.25
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M626.35 480.69s3.6-72.91 45.24-113.58c17.48-17.06 29.11-38.88 32.45-62.62a179.34 179.34 0 0 0 1.44-34",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M731.56 244.73c-2.93 8.11-26.68 26.53-26.68 26.53s-6.79-28.61-3.87-36.71 12.14-12.4 20.57-9.59a15.4 15.4 0 0 1 9.98 19.77zM740.56 298.06c-7 5.27-37.39 8.32-37.39 8.32s10.47-27.55 17.51-32.83a16.6 16.6 0 0 1 22.69 2.7 15.14 15.14 0 0 1-2.81 21.81zM711.81 374.47c-8.85 1.14-36.65-11-36.65-11s23.51-18.7 32.36-19.84 17 4.83 18.16 13.34-5.03 16.32-13.87 17.5zM676.48 427.47c-8.52 2.56-38-4.85-38-4.85s19.89-22.25 28.41-24.81 17.59 2 20.25 10.19a15.44 15.44 0 0 1-10.66 19.47zM670.56 297.26c4 7.67 30.08 22.92 30.08 22.92s2.81-29.21-1.2-36.88a16.47 16.47 0 0 0-21.7-6.9 15.26 15.26 0 0 0-7.18 20.86zM630.09 359.83c6.21 6.16 35.83 13.21 35.83 13.21s-6.41-28.68-12.62-34.84a16.64 16.64 0 0 0-22.86-.34 15.11 15.11 0 0 0-.35 21.97zM599.41 425.84c5 7.08 33 18.84 33 18.84s-1.28-29.31-6.32-36.39a16.58 16.58 0 0 0-22.47-4.05 15.17 15.17 0 0 0-4.21 21.6z",
  fill: "#00c7fa"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M668.86 125.13l-28.76 5.55s50.18-4.73 65.2-3.94 48.88 19.73 48.88 19.73 16 5.08 34.91 22.89a146.66 146.66 0 0 1 12.92 13.82c15.1 18.3 30.26 45.13 39.64 83.93 1 4 1.87 8.06 2.7 12.27 1.68 8.53 3.09 17.58 4.17 27.19.5 4.45.94 9 1.29 13.72q.53 6.72.82 13.78.28 6.72.37 13.74c.07 6.28 0 12.73-.15 19.39q-.18 6.65-.55 13.55v.55c-1.69 31.32-5.6 57.87-11 80.36-.56 2.33-1.14 4.63-1.73 6.87a271.16 271.16 0 0 1-10.01 30.51q-1 2.63-2.09 5.13-2.48 5.87-5.09 11.19-2.16 4.38-4.39 8.41c-.29.55-.6 1.09-.9 1.62-.73 1.29-1.47 2.55-2.21 3.78-25.89 43.3-57.66 53.85-70.32 56.41-1.75.35-3.14.56-4.1.67h-.07c-.94.11-1.45.13-1.45.13-3 11.4 2.72 16 9.6 17.65a29.11 29.11 0 0 0 3.38.59 49.56 49.56 0 0 0 13.49-.54s30.88 1.37 63.3 2.14l7.35.17 2.72.05c16.77.33 33.13.45 45.06.09 5.66-.17 10.32-.45 13.54-.86 24.51-3.17 17.39-19 9.88-31.23-6.46-10.54-3.26-29.28 7.33-60.24q2.57-7.53 5.71-16c11.61-31.47 10.94-78.51 8.21-118.33-.36-5.25-.75-10.38-1.16-15.32-.5-6.07-1-11.87-1.51-17.31-2.2-24.25-9.34-50.38-16.94-71.4-1.09-3-2.19-6-3.29-8.76a212.48 212.48 0 0 0-10.88-23.92c-.88-1.59-1.71-3-2.48-4.19l-.7-1.11c-1.33-2.14-2.72-4.6-4.15-7.29-2.09-3.92-4.26-8.34-6.4-12.91-5.45-11.65-10.75-24.39-14.25-33-2.55-6.31-4.14-10.45-4.14-10.45a15.83 15.83 0 0 1 1.74-4.84c13.29-24.29 90.33-38.24 90.33-38.24l38.62 2.78 76.77 5.52-83.83-12.66-13-2s3.77-.4 9.35-1.3c11.07-1.8 29.27-5.57 39.25-12.14 8-5.24 50.2-7.48 88.08-8.43v-9.64l-7.07 5-81.39 1.21 39.52-50.58-52.17 53.34c-8.2 1.64-24 5.36-42.13 9.78-12.5 3.05-26.12 6.46-39.12 9.68-32 8-60.56 15.32-60.56 15.32a140.77 140.77 0 0 1 55.47-102.72L965.14.47h-11.58c-33 19.69-82.71 59.05-82.71 59.05s.83-21.77 7.83-59H863.5q-.27 2.87-.69 5.7c-6 40.63-8.93 88.51-8.93 88.51-5.14 34.78-19 5.14-19 5.14 1.24-39.52-14.69-76.4-27.43-99.4h-16.84c7.78 15.86 5.18 27.44 5.18 27.44C769.99 8.69 749.47 2.2 735.44.47a59.65 59.65 0 0 0-15.63 0A27.73 27.73 0 0 0 714 1.82c52.16 2.37 89.3 41.88 89.3 41.88 4.14 1 14.58 33.32 19 74.32.65 6 1.18 12.23 1.53 18.56 1.19 21.15-1.47 29.76-4.9 32.7-2.51 2.16-5.44 1.25-7.57 0a15.29 15.29 0 0 1-2.94-2.28c-8.12-13.6-39-29.07-67-40.9-5.93-2.5-11.74-4.84-17.18-7a64.18 64.18 0 0 1-38.42-43.12c-9.17-33.51-26.36-32.23-26.36-32.23 20.16 15.41 19 62 19 62l-66.76-14.1c31.73 8.52 83.75 28.33 83.75 28.33l-26.55 5.11zM594.26 88.01l17.41 3.68a122.12 122.12 0 0 0-17.41-3.68z",
  fill: "#dea3a2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M794.35 564.82s14.69-8.7 34.82-4.35 50.95 2 53.76 1.57zM858.73 328.2s4.9 77.24-3.81 92.47zM876.8 420.67s-6.27 72.35-10.62 86.49 10.62-86.49 10.62-86.49zM882.93 242.79c4.44 1.68 23.48 40.26 19.63 51.68s-19.63-51.68-19.63-51.68zM834.65 202.7c2.07.94 10.92 23.18 9.15 29.76s-9.15-29.76-9.15-29.76zM917.09 332.47c-2.2 22.43-3.39 37.12-2 55.07a211.23 211.23 0 0 1-.6 41.88zM678.69 71.24c2.68 3.06 3.58 7.3 3.71 11.37s-.4 8.14-.13 12.19c.29 4.27 2.31 9.28 6.55 9.85z",
  opacity: 0.1
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M891.2 49.72a46.59 46.59 0 0 0-8.87 6.11 15.87 15.87 0 0 0-5.16 9.24c-.19 1.52-.09 3.08-.43 4.58a14.45 14.45 0 0 1-3 5.55 75.44 75.44 0 0 1-7.49 8.29",
  fill: "none"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M865.39 152.9a55 55 0 0 1 7.15-5 30.1 30.1 0 0 1 7.35-3.23c3.94-1 8.09-.89 12.14-1.31s8.3-1.55 11.07-4.55zM1026.07 102.98c-4.81.13-9.8.3-14.08 2.5-2.18 1.13-4.08 2.73-6.22 3.93a18.92 18.92 0 0 1-9.07 2.36zM959.4 122.81c1-.8 2.6-.18 3.45.81s1.34 2.26 2.22 3.22c1.75 1.9 4.62 2.11 7.2 2.21zM931.9 20.68l-4.62 2.42c-4.72 2.47-9.47 5-13.62 8.31zM879.11 65.86c-3-.72-5.66 2.52-6.2 5.59s.09 6.32-.78 9.31c-.77 2.66-2.64 4.84-4.55 6.83zM827.7 71.47c-2.76 8.25 3.1 17.26 1.39 25.79-.52 2.6-1.73 5-2.34 7.6-1.61 6.78 1.15 14 5.59 19.39z",
  opacity: 0.1
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 237.65,
  cy: 719.04,
  rx: 25.44,
  ry: 3.49,
  fill: "#00c7fa",
  opacity: 0.1
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 140.21,
  cy: 728.92,
  rx: 25.44,
  ry: 3.49,
  fill: "#00c7fa",
  opacity: 0.1
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 25.44,
  cy: 715.54,
  rx: 25.44,
  ry: 3.49,
  fill: "#00c7fa",
  opacity: 0.1
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 179.21,
  cy: 757.05,
  rx: 18.08,
  ry: 2.48,
  fill: "#00c7fa",
  opacity: 0.1
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 78.08,
  cy: 754.57,
  rx: 18.08,
  ry: 2.48,
  fill: "#00c7fa",
  opacity: 0.1
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M139.66 728.13s35.68-116.95-5.58-163.79c-30.87-35-65.9-30.85-81.59-26.52a29 29 0 0 0-18.72 15.55c-5.48 11.84-4.49 31.05 34.23 53.47 64.84 37.53 68.87 89 68.87 89z",
  fill: "#00c7fa"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M58.07 554.41s105.17 32.88 81.59 173.72M119.5 566.2s-14.48 9.76-9.88 24.42M68.62 574.88s8.85-9 19.63-4M110.19 620.18s15.55-7.89 19.57 2M148.66 636.62s-11.67-.93-11.89 4.65",
  fill: "none",
  stroke: "#565987",
  strokeMiterlimit: 10
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M141.11 729.07s-41.79-85-53.27-83.14c-5.45.88-8 6.24-9.1 11.63a34.22 34.22 0 0 0 2.28 20.69c5.93 13.6 21.85 39.43 60.09 50.82z",
  fill: "#00c7fa"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M88.15 662.06s43.86 63.59 52.34 66.38M84.12 671.98h10.24M96.38 695.25l16.05.69M106.15 676.64l-1.74 8.35M123.21 702.07l-.31 7.6",
  fill: "none",
  stroke: "#565987",
  strokeMiterlimit: 10
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M139.86 729.07s41.79-85 53.27-83.14c5.45.88 8 6.24 9.1 11.63a34.22 34.22 0 0 1-2.28 20.69c-5.93 13.6-21.85 39.43-60.09 50.82z",
  fill: "#00c7fa"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M192.82 662.06s-43.86 63.59-52.33 66.41M196.85 671.98h-10.24M184.59 695.25l-16.05.69M174.83 676.64l1.74 8.35M157.76 702.07l.31 7.6",
  fill: "none",
  stroke: "#565987",
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M68.12 748.92a7.31 7.31 0 0 1-2.38-3.59 3.19 3.19 0 0 1 1.66-3.66c1.53-.58 3.16.48 4.4 1.54s2.65 2.29 4.27 2.07a6.51 6.51 0 0 1-2-6.09 2.56 2.56 0 0 1 .56-1.24c.85-.9 2.38-.51 3.4.2 3.22 2.27 4.12 6.65 4.14 10.6a19.93 19.93 0 0 0 .06-4.37 4.48 4.48 0 0 1 1.64-3.86 4.86 4.86 0 0 1 2.5-.59c1.45-.05 3.06.09 4 1.15 1.24 1.32.92 3.53-.15 5a15.86 15.86 0 0 1-4.2 3.37 9.12 9.12 0 0 0-3 2.86 3.42 3.42 0 0 0-.23.51H73.7a25.59 25.59 0 0 1-5.58-3.9zM227.34 714.68a7.22 7.22 0 0 1-2.38-3.59 3.19 3.19 0 0 1 1.66-3.65c1.53-.59 3.16.47 4.39 1.54s2.66 2.29 4.28 2.06a6.5 6.5 0 0 1-2-6.09 2.62 2.62 0 0 1 .56-1.23c.85-.91 2.39-.52 3.4.2 3.23 2.26 4.13 6.65 4.15 10.59a19.84 19.84 0 0 0 .05-4.36 4.48 4.48 0 0 1 1.64-3.86 4.91 4.91 0 0 1 2.5-.59c1.45-.06 3.07.09 4.06 1.15 1.23 1.32.91 3.53-.16 5a15.67 15.67 0 0 1-4.2 3.36 9.53 9.53 0 0 0-3 2.86 2.71 2.71 0 0 0-.22.52h-9.11a25.16 25.16 0 0 1-5.62-3.91zM174.27 748.92a7.31 7.31 0 0 1-2.38-3.59 3.2 3.2 0 0 1 1.67-3.66c1.52-.58 3.15.48 4.39 1.54s2.65 2.29 4.27 2.07a6.53 6.53 0 0 1-2-6.09 2.65 2.65 0 0 1 .56-1.24c.85-.9 2.38-.51 3.4.2 3.22 2.27 4.12 6.65 4.14 10.6a19.93 19.93 0 0 0 .06-4.37 4.48 4.48 0 0 1 1.64-3.86 4.86 4.86 0 0 1 2.5-.59c1.45-.05 3.07.09 4.06 1.15 1.23 1.32.91 3.53-.16 5a15.7 15.7 0 0 1-4.2 3.37 9.22 9.22 0 0 0-3 2.86 2.61 2.61 0 0 0-.22.51h-9.09a25.41 25.41 0 0 1-5.64-3.9zM23.78 679.72s-3.4 4.45 1.58 11.18 9.09 12.41 7.43 16.61c0 0-7.52-12.5-13.64-12.68s-2.1-7.6 4.63-15.11z",
  fill: "#00c7fa"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M23.78 679.72a5.62 5.62 0 0 0-.69 1.39c-6 7-9.15 13.56-3.41 13.72 5.34.16 11.75 9.71 13.29 12.13 0 .18-.11.37-.18.55 0 0-7.52-12.5-13.64-12.68s-2.1-7.6 4.63-15.11z",
  opacity: 0.1
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M17.45 685.4c0 1.56.17 2.84.39 2.84s.39-1.28.39-2.84-.22-.83-.43-.83-.35-.74-.35.83z",
  fill: "#ffd037"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M15.27 687.27c1.38.75 2.58 1.2 2.69 1s-.93-.95-2.31-1.7-.83-.21-.94 0-.81-.05.56.7z",
  fill: "#ffd037"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M41.79 679.72s3.41 4.45-1.58 11.18-9.08 12.41-7.42 16.57c0 0 7.51-12.5 13.63-12.68s2.14-7.56-4.63-15.07z",
  fill: "#00c7fa"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M41.79 679.72a5.62 5.62 0 0 1 .69 1.39c6 7 9.15 13.56 3.41 13.72-5.34.16-11.75 9.71-13.29 12.13a4 4 0 0 0 .19.55s7.51-12.5 13.63-12.68 2.14-7.6-4.63-15.11z",
  opacity: 0.1
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M48.12 685.4c0 1.56-.17 2.84-.39 2.84s-.39-1.28-.39-2.84.22-.83.43-.83.35-.74.35.83z",
  fill: "#ffd037"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M50.3 687.27c-1.38.75-2.58 1.2-2.68 1s.92-.95 2.3-1.7.84-.21.94 0 .82-.05-.56.7z",
  fill: "#ffd037"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M47.04 706.92s-9.53-.29-12.4-2.33-14.66-4.49-15.37-1.21-14.33 16.31-3.57 16.4 25-1.68 27.87-3.42 3.47-9.44 3.47-9.44z",
  fill: "#a8a8a8"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M15.56 718.64c10.76.08 25-1.68 27.87-3.43 2.18-1.33 3.05-6.1 3.34-8.3h.32s-.61 7.69-3.47 9.44-17.11 3.5-27.87 3.42c-3.1 0-4.18-1.13-4.12-2.77.38 1 1.57 1.62 3.93 1.64z",
  opacity: 0.2
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M1015.3 505.17c-4.08-3.46-16.24-24.72-19.68-30.8l-.9-1.62c1.26-4.73-6.64-11.61-8.94-13.5-4.85-5.7-11.8-12.8-17.53-14.5-7.34-2.17-12.47.27-18-.68a14.06 14.06 0 0 1-3.89-1.25 19.42 19.42 0 0 1-2.33-1.38 28.48 28.48 0 0 1-5.28-5.05 11.48 11.48 0 0 0 3-.79q8.55-3.19 16.8-7.1c1.19-.57 2.48-1.25 2.95-2.48.2-.52.23-1.1.47-1.6.52-1.12 1.86-1.55 3-1.91 4.22-1.28 8.8-3.8 9.5-8.15a11 11 0 0 0 .1-1.72 7.32 7.32 0 0 1-.8 1.27c.15-1.47-.08-3 .14-4.43a8.88 8.88 0 0 1 1.46-3.52 11.75 11.75 0 0 0-.08 1.45c1.64-3.55 5.59-6.12 6.89-9.95a11.11 11.11 0 0 0 .52-3.15 11 11 0 0 1-.9 1.69c.73-4.33-1.17-9.23 1.06-13 .15-.25.32-.5.49-.73a12 12 0 0 0-.13 1.48c.11-.25.23-.5.37-.75 1.05-1.78 2.91-3.09 3.45-5.09a5.82 5.82 0 0 0 .08-2.24 10 10 0 0 1-.68.93 12.53 12.53 0 0 0-.41-2.77c-1.59-6.86-3.91-14.65-10.34-17.5-1.95-.87-4.2-1.23-5.76-2.69-3.57-3.32-1.64-10.42-5.75-13-1.81-1.15-4.59-1.27-5.28-3.3-.39-1.15.14-2.47-.29-3.62-.91-2.45-4.48-1.57-7.09-1.48-3.62.14-7.36-3.05-6.83-6.63a19 19 0 0 0-15.76-.74c-2.64 1.07-5.23 2.78-8.06 2.52-1.37-.13-2.64-.71-4-.95-5.6-1-10.39 3.81-15.72 5.8-5.55 2.07-12.37 1.25-16.79 5.21-3.88 3.49-4.59 9.67-8.7 12.88-2.19 1.7-5 2.31-7.33 3.87s-3.89 4.92-2.13 7.07c2.22 2.72 7.92 1.26 9 4.6.87 2.69-2.47 4.69-3.75 7.2a5.59 5.59 0 0 0 3.85 7.7v.08a36.22 36.22 0 0 0 17.26 43.56c.5.9 1 1.91 1.56 3 3.11 6.18 6.72 14.84 7.79 23.28-3.74-1.23-11.61 5.93-11.61 5.93a85.92 85.92 0 0 1-12.13 2.21c-8.41 1.1-7.73 4.39-7.72 4.42l-.53.48C865.57 467.54 836 494 831.26 495l.25 1-1.22.9-14.65 10.85s-11.22.74-22.25 2-26.66 4.61-15.26 17.87c.32.38.64.72 1 1L734.91 526a1.94 1.94 0 0 0 .49-1.17c0-1-1.14-2-3.1-2.75l-.07-.31c5.57-.16 12.49-.41 17.11-.83 1.2-.12 2.23-.24 3-.37 6.9-1.11-.55-6.36 2.76-10.5s0-19.63.27-22.94-2.2-16.58-4.41-19.35-2.48-14.65-2.48-14.65-5.24-4.7-8.27-20.73-15.17-24.32-19-25.15-9.65-4.14-9.65-5-6.62-1.11-9.38-2.21-4.14-2.49-6.34-2.77a12.31 12.31 0 0 0 1.95-2.92 6.73 6.73 0 0 1 2.39-2.67 3.56 3.56 0 0 1 .61-.25 2.37 2.37 0 0 1 .65-.09 1.88 1.88 0 0 1 .66.09c.82.23 1.66.92 2.39.51a.87.87 0 0 0 .27-.23 2.23 2.23 0 0 0 .43-1c.09-.41.16-.83.21-1.25v-.09c.05-.43.08-.86.1-1.29.15-3.12-.29-6.35 1.16-9.06l.09-.13c1.46-2.6 4.33-4 6.66-5.91q.72-.58 1.38-1.23c.17-.16.32-.34.49-.52s.51-.53.75-.81.38-.49.57-.73.36-.47.52-.71.4-.59.59-.9.25-.4.36-.6.39-.7.57-1.07c.08-.16.16-.33.23-.49.19-.4.36-.81.52-1.22.05-.13.09-.26.13-.38.17-.46.32-.91.45-1.38v-.23a18.59 18.59 0 0 0 .57-3A19.68 19.68 0 0 0 716 345.3c-2.55-3-6.21-5.62-6.41-9.53a14.94 14.94 0 0 1 1.2-5.36 13.36 13.36 0 0 0 .58-2.3 6.35 6.35 0 0 0 .09-1.07c0-2.91-1.84-5.5-4-7.49a25.68 25.68 0 0 0-23.11-6.1c-2.13.52-4.28 1.32-6.46 1.05-2.54-.32-4.64-2-6.92-3.17-7.46-3.78-17.57-1-22.09 6-2.61 4.08-3.63 9.39-7.53 12.25-2.3 1.69-5.48 2.43-7.13 4.62a4.86 4.86 0 0 0-.52.81 6.12 6.12 0 0 0-.59 2.74 18.65 18.65 0 0 0 .24 2.88 13.21 13.21 0 0 0 4.19 8.05l.57.6.13.14c.4.44.78.88 1.12 1.33l.06.09.31.44c-.14.17-.29.33-.42.5a33.2 33.2 0 0 0 4.9 46.38v1.06c-.09 1.85-.22 3.81-.38 5.81a4.75 4.75 0 0 0-3.77-1.31 4 4 0 0 0-1.88.18 4.82 4.82 0 0 1-1.08.22c-1.42-.12-2.74-.63-4.13-.48a4.63 4.63 0 0 0-3.89 1.36c-2.74 2.52-12.27 5.79-16.89 6.06a2.88 2.88 0 0 1-1-.25 2.45 2.45 0 0 0-1.52-.14c-2.91-.65-11 5-12.82 8.43-1.93 3.59-8.27 13.26-8.27 13.26s-5.52 6.64-4.69 10.23-1.93 7.74-5.24 9.4-9.93 18.24-9.93 18.24-7.17 15.2-14.62 19.07c-2.92 1.52-3.84 5-3.89 8.75-1.72.09-3 .09-3 .09s-23.17 5.9-30.52 1.47-33.1-5.52-33.1-5.52L457.31 466l-1.06-1.14c4.64-3.95-3.18-6.85-3.18-9.75s-2.94-4.06-2.94-4.06-.13.17-.34.4a5.13 5.13 0 0 0-.76-.4 7.27 7.27 0 0 1-2.17 1.85c-.54-.35-.89-1.39-.77-3.69.22-4.49-2.69-9.24-5-12.27 3.31-10.76 9.5-22.86 14.24-31.3.27-.5.55-1 .82-1.45a32.35 32.35 0 0 0 11-50.91c-.34-.39-.69-.76-1.05-1.13a6.89 6.89 0 0 1 .81-.23 6 6 0 0 1 1.05-.1c2.37.06 5.1 1.15 7.31 1.05a4.33 4.33 0 0 0 2.05-.4c2.42-1.2 1.85-4.42.43-6.05-1.75-2-4.5-3.33-5.77-5.57a17.81 17.81 0 0 1-1.31-4.28 15.28 15.28 0 0 0-9.32-9.64 19.66 19.66 0 0 0-14.66.32c-2.17 1-4.08 2.31-6.33 3.12-4.65 1.68-10 .76-14.81-.58-2.81-.78-5.61-1.7-8.46-2.33a42.35 42.35 0 0 0-3.89-12.31c-.15-.31-.33-.6-.49-.91 4.8-1.66 11.06-1.36 13.56-5.71a9.56 9.56 0 0 0 4.55-.59c1.38-.69 2.42-2.35 1.86-3.8a3 3 0 0 0-.61-.92 11.47 11.47 0 0 0-2-1.51 11.82 11.82 0 0 1-5.08-9.1c0 .08 0 .16.07.25a10.77 10.77 0 0 1 0-1.27c.08-1.91.63-3.79.51-5.7a7.28 7.28 0 0 0-.54-2.31v.15a8.42 8.42 0 0 0-7.91-5.39c-1.25.06-2.48.4-3.73.44-6 .17-10.95-6.56-16.76-5.2-1.24.29-2.42 1-3.69.95-2.93 0-4.74-3.36-7.54-4.24-2.22-.71-4.64.27-7 0s-4.12-1.58-6.08-2.65c-4.19-2.29-9.8-3.3-13.47-.24a12.21 12.21 0 0 1-2.62 2.1 7.6 7.6 0 0 1-3.8.22 35.23 35.23 0 0 0-11.35.77 4.28 4.28 0 0 0-2.6 1.35 7.6 7.6 0 0 0-.82 2.65c-1.12 4.35-6.48 5.82-10.95 6.19a6.3 6.3 0 0 0-3.3.89c-1.61 1.23-1.56 3.7-.85 5.6s1.92 3.63 2.18 5.64c.65 5-4.78 8.87-5.68 13.88-1.26 6.92 6.41 13.72 3.8 20.26-1.15 2.9-4.23 5.14-4.09 8.26s3.16 4.92 5 7.3 2.51 5.17 3.21 8c1.08 4.33 1.28 12.5 5.92 14.58a4.69 4.69 0 0 0 .6.24 6.82 6.82 0 0 0 .78.19c-.22.32-.43.64-.65.95-5.42 7.74-11.49 15.27-17.17 19.91-.2.17-.41.33-.62.49a4.46 4.46 0 0 0-2.45-1.08c-3.31-.37-11.77 5.53-11.77 8.47S293.86 402 285 410.47s-8.82 49-5.88 56.75c1.16 3.07 2.79 11.06 4.33 19.58a10.84 10.84 0 0 0-4 5.85c-3.31 14 1.47 25.05 5.51 26.16S288 514 288 514c-3.23-7-3.84-12.41-2.63-16.52C286.85 506.55 288 514 288 514s10.67 33.9 14.71 44.22 18.39 74.81 18.39 74.81 1.57 2 4.38 4.85l3.34 18.36 5.51 11.06h.41l-.83 7.88s.73 33.17-1.11 38.14-18.2 95.08-18.2 95.08-5.15 31.69-4.78 39.43l11.95 2.58s-2.39-6.82 1.11-19.53 10.29-36.48 10.29-36.48l7-31.69.53 22.66s-6.25 28.19-5 29.66 10.84 2 10.84 2 0-15.11 2-23.4c1.76-7.23 21.28-82.13 26.24-101.18a47.05 47.05 0 0 1 21.56-3.48c24.77 1.38 38.63 10.44 46.37 19.73-17.75 9.38-32.7 17.12-32.7 17.12l.18 1-.16.09-.38.23-.19.11-.36.22-.27.15-.41.25-.26.15-.5.29-.23.13-1.64 1-.18.1-.71.41-.21.12-.75.43-.2.12-.85.49-.11.06-1 .56-1 .58-.1.06-.91.51-.25.14-.74.42-.35.2-.68.37-.34.19-.75.41-.26.15-1 .55-.94.51-.26.13-.71.38-.3.16-.62.32-.33.17-.61.32-.27.14-.72.36-.12.06-.8.4-.18.08-.56.27-.24.11-.45.2-.24.11-.39.16-.22.09-.36.14-.17.07-.45.15c-4.73 1.43-8.11 13.42-3 21.13s4.05 21.13 1.35 26.27.67 14.28 1.35 16.57c.51 1.74 6.71 3.63 16.49 3.19a69.52 69.52 0 0 0 15.72-1.19c15.55-2.86 9.8-9.14 8.11-13.71s-2-17.71.34-23.7q.24-.63.42-1.29c3.66-4.07 9.5-10.74 14.17-16.82 2.15-2.8 7.58-5.29 14.18-7.41 5.28 21.65 15.8 64.51 18.12 71.35 3.12 9.21 4.78 31.88 4.78 31.88l12.13-1.11-4-60.25-4.35-48c5.74-1 10.18-1.63 11.62-1.83 5.92 22.78 11.55 44.48 12.46 48.21 2 8.29 2 23.4 2 23.4s9.56-.55 10.85-2-5-29.67-5-29.67l1.17-49.86c13.73-6.43 30.43-14.19 37.81-17.4 6.94-3 18.47-10.13 28.11-16.4l17 138.75 9.93.83 5.31-1.21 6.82-1.55 15.6-125.07c.62.49 1.19.95 1.69 1.37-.34 3.13-.65 8.45.64 12.32 1.93 5.8 1.65 18.51.27 22.94s-6.06 10.5 6.62 13.26 21.24.28 21.79-1.93 3.31-11.06 1.1-16-3-18 1.1-25.43 1.38-19.07-2.48-20.45c-2.56-.92-6.32-2.56-8.58-3.57l-.72-.91a18.73 18.73 0 0 1 6-5.2c6.62-3.31 5.24-10.77 5.24-10.77s6.9 0 11.86-8.3c3.48-5.81 7.49-11.61 9.59-15.81.42 2.67.9 6 1.17 8.81.55 5.9 7.35 63.2 10.48 68s.55 22.85.55 22.85h10.11l-.73-27.64s-11.4-81.25-1.84-89.55c1.67-1.45 3.3-2.94 4.85-4.4l18.86 137.91c-.05 1-.09 1.72-.12 2.26s-.06 1-.06 1-8.09 4.06-2.2 8.1a15.06 15.06 0 0 0 4.16 1.74l.41 3a42.91 42.91 0 0 1-6.41 0c-1.29-.55-1.29 17.13-1.29 17.13s-7.17 14.38-8.09 17.88-8.09 12.16-8.09 12.16-10.3 7.55 4.78 10.5 31.62-.92 31.62-.92 11-19.16 12-18.06 0 10.14 0 10.14l6.44-1.66s-1.11-12 1.47-18.43c2-5.12-2.41-21.29-4.33-27.72l1.2.09s1.1-2.21 2.21-8.85q0-.31.09-.6a85.57 85.57 0 0 1 3.59-14.14c1.83-5.9 0-5.16 0-8.85a134.22 134.22 0 0 1 2-18.93c0-.19.07-.37.11-.56a8.82 8.82 0 0 0 2.68 1.19c1.1 3.06 2.26 6.57 3 9.5-2 .62-3.35 1.34-3.57 2.17-1.11 4.06.36 12.71.36 12.71s1.65 19.54-1.47 22.49-9.56 8.29-5.33 13.82a7 7 0 0 0 1.47 1.37c3 2.18 8.76 3.75 14.56 4l-2.42 36.1 12.02 1.12s1.65-22.67 4.78-31.88c.69-2 2.12-7.32 3.92-14.28 4.55-6.83 7.11-11.7 7.11-11.7l3.13 12.9 10.84-2.77s-5.88-11.42-5.15-15.47-3.12-9.76-6.24-14.37c-.39-.57-.81-1.3-1.26-2.13 4.65-18.87 8.79-36 8.79-36s2.94-38.3 56.08-41.3a47 47 0 0 1 21.55 3.48c5 19 24.49 94 26.25 101.18 2 8.29 2 23.4 2 23.4s9.56-.55 10.85-2-5-29.66-5-29.66l.53-22.66 7 31.69s6.8 23.76 10.29 36.48 1.1 19.53 1.1 19.53l11.95-2.58c.37-7.74-4.78-39.43-4.78-39.43s-16.36-90.1-18.2-95.08-1.1-38.14-1.1-38.14l-.81-7.72c13-9.15 20.3-58.06 20.3-58.06l13.56-75.82a91.85 91.85 0 0 0 5.4-12.16v-.07l1.62 1.82 7.88 19.35c15.62 21.93 31.25 21.19 31.25 21.19a1.11 1.11 0 0 0 .07-.16 10.35 10.35 0 0 0 8-2.1l.16-.13c5.67-4.43-6.09-36.12-10.88-40.18zM739.39 551c-.9-3.62-1.88-7.58-2.91-11.74l3.13-.06zm-47.08-153a9.08 9.08 0 0 0-.94.66c-.29-.74-.56-1.5-.83-2.26a5.25 5.25 0 0 0 1.77 1.6zm-94.63 160.42c-4.69 6.09-5.24 10-5.24 10l1.18.27-8.51 7.61-4.29-36.87 20.75.9c-1.17 9.11-2.5 16.28-3.89 18.09zm20.13 76.84s4.28-1 9.86-2.62l-1.77 13.3c-5-6.49-8.09-10.68-8.09-10.68zm-11.91-146l.15-.34v.35zm-106.13 91.46c-4.64-2.1-37.42-12.17-49.35-15.82a2.42 2.42 0 0 1-.29-1.87c1.11-3.68-7.35-13.63-10.66-16.21s-7.72-7.37-4.05-10.32a6.24 6.24 0 0 0 1.79-3.35l34.18 1.49a83.78 83.78 0 0 0 10 3s5.81-.76 13.45-2l67.64 2.93 6.42 52.31c-4.21 3.86-7.07 6.56-7.07 6.78 0 .48-4.53 8.2-5.08 18.37l-35.29-11a5.1 5.1 0 0 0 .19-.55c3.35-12.15-16.18-21.18-21.88-23.76zm-61.87-56.11c-.06-2.47-.27-4.33-.27-4.33l-.76-8.24c6.66 4.07 13.86 8.59 19 12.12zm159.32 155.74l.73-.5a10.09 10.09 0 0 0 5-3.46c2.95 2.57 5.7 4.94 8.11 7-2.82 2.6-7.78 6.83-12.45 9.06zm140.88-57.61l-1.3 71.64-9.91-66.38c2.8-1.39 7.18-3.42 11.21-5.26zm61.9-97.48s10.66 13.27 18.94 8.84c1.86.24 15.41-7.08 24.1-11.9a39.44 39.44 0 0 0 4.21 5.08l5.26-2.72 1.05-.54c.52 5.71 1.42 15.22 2.15 21.32 1.1 9.17-14.2 21.63-14.34 21.74s.06.46.1 1.18c-.75.67-1.2 1-1.2 1l1.23-.22c.11 2.89-.1 8-2.71 9.07-3.67 1.48-5.88 2.58-13.24.37a137.55 137.55 0 0 0-27.28-4.48c-12.77-.74-26.44.64-33 8.16-.23.27-.45.56-.66.86s-.22.33-.33.49a3.24 3.24 0 0 0-.66.31s0 .24.1.62c-3.56 6.42-4.55 18.29-4.33 31.07l-1.1.47-.54.25-.41.2c-.38.17-.76.36-1.14.55l-.68.34-.88.47-1 .55-.57.34c-.42.24-.84.5-1.26.77l-.3.19c-.48.32-1 .64-1.43 1l-.12.1c-.18.12-.35.25-.52.38l1.24-82.12 54.39-1-.83-7.74-8.4-.51a23.12 23.12 0 0 0 4.16-4.49zM409.81 729.89l.3-.75c0-.06.05-.12.08-.19l.29-.66.29 1.57c-.4.23-.8.47-1.22.7.09-.22.17-.44.25-.65zM602 721.4a81.33 81.33 0 0 0 14.37-4l-7.93 59.36zm135.47 52.53c.72.17 1.47.33 2.24.49v1.73l-2.34.12z",
  transform: "translate(-37.44 -49.53)",
  fill: "url(#a)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M1110.55 744.39c0-2.14-8.71-4-21.52-5-3.48-5.8-8.94-12.1-9.5-14.67-.76-3.48-9.23-3-16.25-1.27 4.42-5.68 10.79-12.35 16.43-12.52 5.9-.16 5.94-4.53 2.7-10.61a20.52 20.52 0 0 0 3.55-1.59c2.21-1.22 1.07-.83.9-1.14s.71-1.19-1.51 0a20.75 20.75 0 0 0-3.22 2.09 19.68 19.68 0 0 0 .32-4c0-2.53-.21-1.34-.56-1.34s-.7-1.19-.7 1.34a26.43 26.43 0 0 0 .12 2.69 84.27 84.27 0 0 0-9.06-11.85v.07c.06.09.15.22.25.4v.05c0 .07.09.16.13.25v.06a7.31 7.31 0 0 1 .36.78.42.42 0 0 1 0 .1l.15.38c1.05 2.91 1.77 8.56-3.63 15.87s-10.32 14.07-12 19.69c-1.65-5.62-6.47-12.26-12-19.69s-4.68-13-3.63-15.87l.15-.38v-.1q.2-.45.36-.78v-.06c0-.09.09-.18.13-.25v-.05a3.26 3.26 0 0 1 .25-.4v-.07a84.27 84.27 0 0 0-9.06 11.85c.07-.76.12-1.68.12-2.69 0-2.53-.35-1.34-.7-1.34s-.57-1.19-.57 1.34a19.52 19.52 0 0 0 .33 4 20.75 20.75 0 0 0-3.22-2.09c-2.22-1.21-1.34-.33-1.51 0s-1.32-.08.9 1.14a20.52 20.52 0 0 0 3.55 1.59c-3.24 6.08-3.2 10.45 2.7 10.61 6.78.2 14.64 9.83 18.87 15.8-4.22 2.89-16.69 3.58-19.36 3.69h-.51a47.8 47.8 0 0 0 1.06 6.55 28.88 28.88 0 0 0 1.21 3.94c-5.29.95-8.45 2.13-8.45 3.42 0 2.7 13.83 5 32.27 5.51a220.06 220.06 0 0 0 24.36 1.32c.5 0 1 0 1.38-.06h.2c.4 0 .77-.1 1.12-.16l.21-.05a7.37 7.37 0 0 0 .93-.25l.14-.06a6.17 6.17 0 0 0 .73-.33h.09a4.55 4.55 0 0 0 .6-.42l.12-.11a2.74 2.74 0 0 0 .43-.48l.06-.07c12.08-.99 19.78-2.76 19.78-4.78z",
  transform: "translate(-37.44 -49.53)",
  fill: "url(#b)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M385.26 702.94s2 9.38-.34 15.35-2 19-.34 23.6 7.42 10.8-8.09 13.65-26 .28-26.63-2-4.05-11.37-1.35-16.49 3.71-18.48-1.35-26.16-1.69-19.61 3-21 25.09-13.53 25.09-13.53-7.55 13.11.55 16a14.69 14.69 0 0 1 9.46 10.58z",
  fill: "#575a88"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M555.76 630.2s-31.2 21.65-44.76 27.51-58.7 27.15-58.7 27.15-45.48 5.87-52.82 15.41-17.61 20.55-17.61 20.55l-8.07-44.76s89.51-46.23 90.24-49.53 26.42-13.21-48.42-12.84c-65.58.33-89.75 4.59-95.23-4.48a10 10 0 0 1-1.26-4.69c-.74-15 88.05-81.45 88.05-81.45s4.34 2.26 9.52 5.3c5.68 3.32 12.36 7.59 15.43 10.85 5.87 6.23 20.17 8.07 20.17 8.07l87.32 27.18s25.68 8.07 26.41 30.82-10.27 24.91-10.27 24.91z",
  fill: "#aac9f5"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M566.03 605.26c-.73-22.79-26.41-30.79-26.41-30.79l-87.32-27.15s-14.3-1.84-20.17-8.07c-3.07-3.26-9.75-7.53-15.43-10.85-5.18-3-9.52-5.3-9.52-5.3s-88.79 66.4-88.05 81.45a10 10 0 0 0 1.26 4.69c5.48 9.07 29.65 4.81 95.23 4.48 74.84-.37 49.15 9.54 48.42 12.84s-90.24 49.53-90.24 49.53l.18 1c-4.54 2.68-19.78 11.57-23.79 12.77-4.72 1.43-8.09 13.37-3 21s4 21 1.35 26.16.67 14.21 1.35 16.49 11.12 4.83 26.63 2 9.78-9.1 8.09-13.65-2-17.63.34-23.6a12.78 12.78 0 0 0 .42-1.28c3.65-4 9.48-10.69 14.14-16.74 7.34-9.54 52.82-15.41 52.82-15.41s45.13-21.27 58.7-27.15 44.76-27.51 44.76-27.51 10.98-2.18 10.24-24.91zm-190.2 87c-6.07-2.14-3.35-10.05-1.61-13.87l2.57 14.26c-.31-.1-.62-.24-.96-.36z",
  opacity: 0.1
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M442.4 627.82s25.31 96.85 27.33 105.1 2 23.3 2 23.3 9.54-.55 10.82-2-5-29.53-5-29.53l1.83-78.51-26.78-22.56z",
  fill: "#d5838e"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffccd0",
  d: "M376.42 679.95h19.81v17.06h-19.81z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M390.76 702.94s2 9.38-.34 15.35-2 19-.33 23.6 7.41 10.8-8.1 13.65-26 .28-26.63-2-4.05-11.37-1.35-16.49 3.71-18.48-1.35-26.16-1.68-19.61 3-21 25.08-13.53 25.08-13.53-7.54 13.11.55 16a14.69 14.69 0 0 1 9.47 10.58zM409.75 514.47s47.87 14.49 53.56 17.06 25.13 11.56 21.83 23.66-30.27 13.4-30.27 13.4l-41.09-15.23-16.14-32.65z",
  fill: "#575a88"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M425.34 346.47s-2.36 3.67-5.56 9.29c-.26.46-.54.94-.81 1.44-8.75 15.57-22.49 43.59-13.72 52.55 12.39 12.66-28.34-7.15-28.34-7.15l-1-1.79-16.63-30.13s13.07-13.2 20.94-24.78c.13-.18.26-.37.38-.56 3.51-5.25 5.88-10.11 5.37-13.18s3.36-2.84 8.87-.9c11.65 4.03 30.5 15.21 30.5 15.21z",
  fill: "#cd828d"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M425.34 346.47s-2.36 3.67-5.56 9.29c-.26.46-.54.94-.81 1.44a32 32 0 0 1-18.19 1.93 32.07 32.07 0 0 1-20.16-12.69c-.13-.17-.25-.35-.38-.54.13-.18.26-.37.38-.56 3.51-5.25 5.88-10.11 5.37-13.18s3.36-2.84 8.87-.9c11.63 4.03 30.48 15.21 30.48 15.21z",
  opacity: 0.1
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M438.82 326.34a32.19 32.19 0 0 1-32.19 32.19 31.44 31.44 0 0 1-5.85-.54 32.18 32.18 0 1 1 38-31.65z",
  fill: "#cd828d"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M430.74 305.03c-1.94.65-3.22 2-5 3-3.11 1.76-7.24 1.71-10.2 3.43-2.45 1.42-2.45 4.4-3.5 6.76-2.75 6.17-12.69 7.75-17.18 13a10.47 10.47 0 0 0-1 1.39c-2.44 4.12-1 9.08.9 13.42a108.86 108.86 0 0 0 6 12c.4.69.81 1.37 1.23 2.05 2.44 4 5.26 8.41 3.76 12.72-2.44 7-14.38 8.63-17.86 15.33-1 2-1.19 4.23-2.28 6.19-1.83 3.32-5.6 5-9.7 6.49l-16.63-30.13s13.5-13.63 21.32-25.34a32.18 32.18 0 0 1 50.12-40.27z",
  opacity: 0.1
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M441.31 298.21c-1.74-2-4.48-3.32-5.75-5.55a17.8 17.8 0 0 1-1.31-4.26 15.19 15.19 0 0 0-9.3-9.6 19.66 19.66 0 0 0-14.62.32c-2.16 1-4.07 2.3-6.31 3.11-4.65 1.66-10 .75-14.78-.58s-9.57-3.09-14.62-3.06-10.53 2.52-11.52 6.72a30 30 0 0 0-.32 3.42c-.6 5.08-5.25 9.18-10.29 12s-10.74 4.75-15.41 8-8.32 8.28-7.06 13.28c.78 3.11 3.29 5.65 5.3 8.34 5.07 6.79 7.1 14.85 9 22.73.68 2.74 1.36 5.58.7 8.33-1.18 4.95-6.29 8.39-9.63 12.57-4.14 5.2-5.55 11.7-5.25 18s2.17 12.41 4.1 18.48a23 23 0 0 0 2.82 6.41c2.43 3.47 6.61 5.75 10.64 7.89a12.48 12.48 0 0 0 5.88 1.94c4.43-.06 7-4.26 7.95-7.93a31.13 31.13 0 0 0 .91-9.31 6.78 6.78 0 0 1 .31-3.32 6.29 6.29 0 0 1 2.56-2.44c6.33-3.8 15.9-4.47 19.18-10.43 1.08-2 1.25-4.2 2.28-6.18 3.47-6.71 15.41-8.31 17.86-15.34 1.5-4.31-1.32-8.74-3.76-12.73a105.57 105.57 0 0 1-7.25-14c-1.85-4.34-3.35-9.3-.91-13.42 3.78-6.39 15.21-7.68 18.19-14.37 1.05-2.35 1.05-5.34 3.5-6.76 3-1.71 7.09-1.68 10.2-3.43 2-1.15 3.4-2.75 5.86-3.27 3.21-.67 7.66 1.91 10.39.55 2.45-1.29 1.88-4.49.46-6.11z",
  fill: "#663d5c"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M440.95 298.21c-1.74-2-4.49-3.32-5.76-5.55a18.75 18.75 0 0 1-1.31-4.26 15 15 0 0 0-8.41-9.2 14 14 0 0 1 4.38 6.63 18.09 18.09 0 0 0 1.3 4.26c1.27 2.23 4 3.56 5.76 5.55 1.42 1.62 2 4.83-.43 6-2.72 1.36-7.17-1.21-10.38-.54-2.46.51-3.83 2.11-5.86 3.26-3.11 1.76-7.24 1.72-10.2 3.44-2.45 1.41-2.45 4.4-3.5 6.75-3 6.69-14.41 8-18.2 14.37-2.44 4.12-.93 9.09.92 13.42a107.46 107.46 0 0 0 7.24 14c2.45 4 5.26 8.41 3.77 12.72-2.45 7-14.39 8.63-17.87 15.34-1 2-1.19 4.22-2.27 6.18-3.29 6-12.86 6.64-19.18 10.43a6.29 6.29 0 0 0-2.56 2.44 6.67 6.67 0 0 0-.31 3.32 31.13 31.13 0 0 1-.91 9.31c-.93 3.68-3.53 7.87-7.95 7.93a12.52 12.52 0 0 1-5.89-1.94c-.88-.47-1.78-.95-2.66-1.45a54.5 54.5 0 0 0 6.7 4 12.48 12.48 0 0 0 5.89 1.94c4.42-.06 7-4.26 7.95-7.93a31.12 31.12 0 0 0 .9-9.31 6.78 6.78 0 0 1 .32-3.32 6.27 6.27 0 0 1 2.55-2.44c6.33-3.8 15.9-4.47 19.19-10.43 1.08-2 1.24-4.2 2.27-6.18 3.48-6.71 15.42-8.31 17.86-15.34 1.5-4.31-1.31-8.74-3.76-12.73a106.78 106.78 0 0 1-7.25-14c-1.85-4.34-3.35-9.3-.91-13.42 3.79-6.39 15.21-7.68 18.19-14.37 1.05-2.35 1.06-5.34 3.5-6.76 3-1.71 7.09-1.68 10.2-3.43 2-1.15 3.4-2.75 5.86-3.27 3.21-.67 7.66 1.91 10.39.55 2.41-1.15 1.84-4.35.43-5.97z",
  opacity: 0.1
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M794.04 446.22s5 21 16 32.09l4.41-9.58-5.51-17.47z",
  fill: "#f26383"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M808.9 451.26l-14.86-5s5 21 16 32.09",
  opacity: 0.1
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M988.66 496.3l-.16.13a10.49 10.49 0 0 1-14.31-1.31l-42-47.13-1.09-1.22 22-25.32 4 2.57.9 1.62c3.44 6.05 15.57 27.21 19.64 30.66 4.8 4.04 16.53 35.59 11.02 40z",
  fill: "#ffc1c7"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M576.67 631.47s-11.28 11.56-19 12.66-14 25.87-3.3 27.79 31.36-5.78 34.39-9.08 14-22.84 14-22.84z",
  fill: "#ffd6db"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M813.12 469.14l-5.48 3.1c-8.46 4.7-23.91 13.13-25.89 12.86-2.75-.36-3.3-26.22-3.3-26.22l14.63-10.81 1.51-1.13 4.41-1.65z",
  fill: "#ffc1c7"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M813.12 469.14l-5.48 3.1a33.59 33.59 0 0 0-14.56-24.17l1.51-1.13 4.41-1.65z",
  opacity: 0.1
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M844.12 439.06l-17.06 30.41-11.81 6.09-5.25 2.71c1.47-22.92-16-32.09-16-32.09 4.77-1 34.23-27.39 38.55-31.27l.53-.47 4-.55z",
  fill: "#00c7fa"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M897.87 603.23l-14.49-11 47.32-157 16.7 6.24-12.66 24.94-13.94 77.76s-8.24 55.4-22.93 59.06z",
  fill: "#e4aab4"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M954.18 418.15l-49.89-.37s-43.66 12.11-40-5.5c2.29-11-3.15-24.74-7.57-33.49-.53-1.06-1-2.06-1.55-3-1.91-3.54-3.35-5.73-3.35-5.73s5.19-.86 11.74-1.78c3-.44 6.38-.88 9.62-1.27 1.7-.21 3.36-.38 4.93-.55 6.42-.63 11.47-.78 11.47.3s1 3.67 2.62 7c.25.53.54 1.08.82 1.63a71.67 71.67 0 0 0 7.9 12.11 29 29 0 0 0 5.54 5.34 18.06 18.06 0 0 0 2.33 1.37 14 14 0 0 0 3.88 1.25c5.57.94 10.69-1.49 18 .68 9.94 2.93 23.51 22.01 23.51 22.01z",
  fill: "#ffc1c7"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M690.56 541.05s-42 23.11-44.58 32.28 6.24 16.51 6.24 16.51 1.47 7.89 2 13.76 7.33 62.92 10.45 67.69.55 22.75.55 22.75h10.14l-.73-27.52s-11.38-80.89-1.84-89.15 17.43-17.61 20.18-16.88-2.41-19.44-2.41-19.44z",
  fill: "#e4aab4"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M638.86 508.22s-27.52 52.55-28.07 59.7-23.94 37.42-23.94 37.42l29.17 36.87s3.85-9.35 10.46-12.65 5.22-10.73 5.22-10.73 6.88 0 11.84-8.26 11-16.51 11-20.08 36.32-41 36.32-41l-2.75-39.9-7.43-12.66z",
  fill: "#bdd2e8"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M567.32 511.24l-.24.21c-3.34 3-40.76 36.15-40.76 36.94s-13.48 23.11 3.3 42.37 55.31 50.9 55.31 50.9 16.78 12.11 19 14.59 35.5 0 15.69-22.56-38.52-47.88-38.52-47.88 33-8 35.22-13.48-43.48-74.3-43.48-74.3z",
  opacity: 0.1
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M566.22 511.24l-.24.21c-3.34 3-40.76 36.15-40.76 36.94s-13.48 23.08 3.34 42.37 55.31 50.9 55.31 50.9 16.78 12.11 19 14.59 35.5 0 15.69-22.56-38.52-47.88-38.52-47.88 33-8 35.21-13.48 45.68-72.92 45.68-72.92l-89.15-1.38z",
  fill: "#bdd2e8"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M661.42 363.21l-3.3 30s-33.85 13.48-34.67 13.21-22.56-19.81-19-32.74c1.8-6.49 2.62-15.48 3-22.82s.31-12.95.31-12.95 49.25-17.61 44.85-5.51c-1.6 4.39-.88 9.67.69 14.59a67.88 67.88 0 0 0 8.12 16.22z",
  fill: "#cf6f80"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M360.4 300.75l-.07.18a156.68 156.68 0 0 0-9.3 25.59l-.3 1.17a62.7 62.7 0 0 0-2.06 18c.67 13.12 7.33 16.15 7.33 16.15s-100.7-16.5-84.2-19.26c2.66-.44 5.56-2.09 8.58-4.54 5.67-4.62 11.72-12.12 17.12-19.82 2-2.84 3.93-5.72 5.69-8.47.12-.18.25-.37.36-.55 6.58-10.26 11.18-18.9 11.18-18.9s69.34-41.83 45.67 10.45z",
  fill: "#ffccd0"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M859.35 622.47s25.31 96.85 27.33 105.1 2 23.3 2 23.3 9.53-.55 10.82-2-5-29.53-5-29.53l1.83-78.51-26.78-22.56z",
  fill: "#d5838e"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M874.2 591.68c.56 0 25.32.55 25.32.55l1.83 17.43s-.73 33 1.1 38 18.16 94.65 18.16 94.65 5.14 31.55 4.77 39.25l-11.92 2.57s2.38-6.79-1.1-19.44-10.27-36.32-10.27-36.32l-8.62-38.9s-1.47-69-54.48-66-55.95 41-55.95 41-18 74.29-21.1 83.47-4.77 31.73-4.77 31.73l-12.1-1.1 4-60 11.19-123.46 34.49-2.38z",
  fill: "#e4aab4"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M339.8 638.47s-25.31 96.86-27.33 105.11-2 23.3-2 23.3-9.54-.55-10.82-2 4.91-29.57 4.91-29.57l-1.83-78.51 26.83-22.56z",
  fill: "#d5838e"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M324.94 607.64c-.55 0-25.31.55-25.31.55l-1.84 17.42s.74 33-1.1 38-18.13 94.63-18.13 94.63-5.13 31.55-4.77 39.25l11.93 2.57s-2.39-6.79 1.1-19.44 10.27-36.32 10.27-36.32l8.62-38.89s1.47-69 54.48-66 55.92 41.06 55.92 41.06 18 74.29 21.09 83.46 4.77 31.74 4.77 31.74l12.11-1.1-4-60-11.23-123.45-34.48-2.38z",
  fill: "#e4aab4"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M653.31 346.98c-.3.35-.61.68-.91 1a33 33 0 0 1-44.94 2.86c.37-7.29.31-12.95.31-12.95s49.25-17.61 44.85-5.51c-1.6 4.4-.88 9.68.69 14.6z",
  opacity: 0.1
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M661.42 324.23a33 33 0 1 1-33-33 32.82 32.82 0 0 1 33 33z",
  fill: "#cf6f80"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M561.26 630.2s-31.18 21.65-44.76 27.51-58.69 27.15-58.69 27.15-45.49 5.87-52.83 15.41-17.61 20.55-17.61 20.55l-8.07-44.76s89.51-46.23 90.25-49.53 26.42-13.21-48.43-12.84c-65.58.33-89.75 4.59-95.23-4.48a10 10 0 0 1-1.26-4.69c-.73-15 88.05-81.45 88.05-81.45s4.34 2.26 9.52 5.3c5.68 3.32 12.36 7.59 15.43 10.85 5.87 6.23 20.18 8.07 20.18 8.07l87.31 27.18s25.69 8 26.44 30.79-10.3 24.94-10.3 24.94z",
  fill: "#aac9f5"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M620.7 394.35s-12.93-28.66-17.34-28.66-11.28 148.25-11.28 148.25l67.41 1.06 2.76-77.84-13.76-69s-12.38 27.25-27.79 26.19z",
  opacity: 0.1
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M620.7 396.55s-12.93-28.66-17.34-28.66-11.28 148.25-11.28 148.25l76.48 1.16-6.32-77.94-13.76-69s-12.37 27.25-27.78 26.19z",
  opacity: 0.1
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M620.7 395.47s-12.93-28.66-17.34-28.66-11.28 148.25-11.28 148.25l76.48 1.13-6.32-77.93-13.76-69s-12.37 27.21-27.78 26.21z",
  fill: "#ffd6db"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M608.15 357.79s-2.31-3.38-5.61-2.28-5.78-1.93-9.08 1.1-16.51 7.15-19 5.77-11.28 4.68-13.21 8.26-8.25 13.21-8.25 13.21-5.5 6.6-4.68 10.18-1.92 7.7-5.23 9.35-9.9 18.16-9.9 18.16-7.15 15.14-14.58 19-1.93 20.63-1.93 20.63l44-1.37 9.91-22.56s-3.85 66-8.53 72.09-5.23 9.9-5.23 9.9 18.16 3.85 22 7.16 14-.83 14-.83l9.9-87.77s3.58-16.51 3.58-25 1.84-55 1.84-55z",
  opacity: 0.1
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M607.05 357.79s-2.31-3.38-5.61-2.28-5.78-1.93-9.08 1.1-16.51 7.15-19 5.77-11.28 4.68-13.21 8.26-8.25 13.21-8.25 13.21-5.5 6.6-4.68 10.18-1.92 7.7-5.23 9.35-9.9 18.16-9.9 18.16-7.16 15.14-14.58 19-1.95 20.62-1.95 20.62l44-1.37 10-22.56s-3.85 66-8.53 72.09-5.23 9.9-5.23 9.9 18.16 3.85 22 7.16 14-.83 14-.83l9.9-87.77s3.58-16.51 3.58-25 1.77-54.99 1.77-54.99z",
  fill: "#575a89"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M546.41 405.58s3.3 9.08 12.38 8.26-12.38-8.26-12.38-8.26zM555.21 391.83s6.05 1.1 8.26 6.32-8.26-6.32-8.26-6.32zM572.27 382.47c0 1.1 3.85 20.36 0 28.34s-3.3 17.34-3.3 17.34zM653.49 351.16s2.15-2.53 4.35-2.26 3.58 1.65 6.33 2.75 9.36 1.38 9.36 2.2 5.78 4.13 9.63 5 16 9.08 19 25 8.24 20.62 8.24 20.62l-29.17 14.31s22.56 95.76 25.33 102.69 3 47.6 3 47.6-17.88 8-22.56 10.46-2.75-23.66-12.38-38.8-20.64-37.14-20.64-37.14l-16.77-47.12s-10.73-62.74-1.65-74.29 18.75-26.89 17.93-31.02z",
  opacity: 0.1
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M654.56 351.16s2.15-2.53 4.35-2.26 3.58 1.65 6.33 2.75 9.36 1.38 9.36 2.2 5.78 4.13 9.63 5 16 9.08 19 25 8.27 20.62 8.27 20.62l-29.17 14.31s22.56 95.76 25.32 102.69 3 47.6 3 47.6-17.88 8-22.56 10.46-2.75-23.66-12.38-38.8-20.64-37.14-20.64-37.14l-16.76-47.12s-10.75-62.72-1.65-74.27 18.75-26.91 17.9-31.04z",
  fill: "#575a89"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M714.25 471.62c-.81.13-1.85.25-3.05.36-8.81.81-26.12 1-26.12 1s-12.93-25.59-23.93-24.77c0 0 10.18-11.55 14.3-10.18.7.23 1.13-.27 1.33-1.26 1.11-4.91-2.7-21.85-2.7-21.85l-5.23-22.84 30.27 7.43c2.75.55 11.28 4.95 11.28 4.95s.27 11.83 2.47 14.59 4.68 15.95 4.41 19.26 3 18.71-.28 22.83 4.13 9.38-2.75 10.48z",
  opacity: 0.1
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M715.35 471.62c-.81.13-1.85.25-3 .36-8.81.81-26.12 1-26.12 1s-12.93-25.59-23.93-24.77c0 0 10.18-11.55 14.3-10.18.7.23 1.13-.27 1.34-1.26 1.1-4.91-2.71-21.85-2.71-21.85L670 392.08l30.27 7.43c2.75.55 11.28 4.95 11.28 4.95s.27 11.83 2.47 14.59 4.68 15.95 4.41 19.26 3 18.71-.28 22.83 4.08 9.38-2.8 10.48z",
  fill: "#575a89"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M684.26 411.64s25.31 2.75 26.41 9.08-26.41-9.08-26.41-9.08z",
  opacity: 0.1
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M601.16 651.85s-1.65 9.08.28 14.85 1.65 18.44.27 22.84-6 10.46 6.61 13.21 21.18.27 21.73-1.93 3.3-11 1.1-16-3-17.88 1.1-25.31 1.38-19-2.47-20.36-10.46-4.4-10.46-4.4 7.16 12.93.55 15.68-18.71 1.42-18.71 1.42z",
  fill: "#ffd6db"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M661.42 324.23a32.82 32.82 0 0 1-9 22.66.6.6 0 0 1-.08-.16c-1-2.09-1.92-4.27-1.84-6.56.09-2.77 1.68-5.27 2.2-8 .65-3.45-.48-7-1.59-10.3-.82-2.44-2.39-5.4-4.95-5.11a5.62 5.62 0 0 1-1.51.18c-1.37-.21-1.64-2-1.8-3.36a15.23 15.23 0 0 0-12.44-13.05 3.81 3.81 0 0 0-2.17.14c-.95.43-1.48 1.47-2.34 2.06-2.79 1.94-6.35-1.77-9.74-1.49-2.88.25-4.64 3.2-5.83 5.84s-2.68 5.64-5.5 6.26a1.72 1.72 0 0 1-1.34-.15c-.88-.64-.27-2 .18-3 1.16-2.62.38-4.7-1-6.56a33 33 0 0 1 58.81 20.61z",
  opacity: 0.1
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M603.64 309.08c-.44 1-1.05 2.36-.16 3a1.7 1.7 0 0 0 1.33.15c2.82-.61 4.31-3.63 5.5-6.26s3-5.6 5.83-5.84c3.4-.28 6.95 3.42 9.74 1.49.86-.59 1.39-1.63 2.34-2.06a3.9 3.9 0 0 1 2.17-.14 15.24 15.24 0 0 1 12.45 13.05c.14 1.36.42 3.15 1.78 3.36a5.64 5.64 0 0 0 1.52-.18c2.56-.29 4.13 2.66 4.94 5.1 1.12 3.34 2.25 6.86 1.6 10.32-.51 2.73-2.11 5.23-2.2 8-.07 2.29.89 4.46 1.84 6.55s2.49 4.52 4.76 4.23c1.86-.24 2.89-2.22 3.78-3.87s2.5-3.43 4.31-2.91c.81.24 1.65.92 2.38.51a1.72 1.72 0 0 0 .69-1.2c.88-3.85-.38-8.17 1.49-11.64 1.44-2.68 4.36-4.12 6.73-6a19.28 19.28 0 0 0 2.61-27.6c-2.54-3-6.19-5.6-6.39-9.49-.16-3 1.84-5.71 1.87-8.69s-1.84-5.48-4-7.45a25.6 25.6 0 0 0-22.99-6.04c-2.13.51-4.28 1.3-6.45 1-2.53-.31-4.63-2-6.91-3.15a17.65 17.65 0 0 0-22 6c-2.61 4-3.63 9.35-7.52 12.19-2.56 1.87-6.22 2.57-7.63 5.4-.85 1.7-.61 3.72-.35 5.6a13.07 13.07 0 0 0 4.18 8c2.32 2.42 4.36 4.96 2.76 8.57z",
  fill: "#512e4e"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffceb4",
  d: "M571.72 726.69l-.27 53.65-9.91-.83-36.04-293.03 10.64-.32 7.52-.23 28.06 240.76z"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  fill: "#f8bda5",
  d: "M571.45 780.34l-9.91-.83-36.04-293.03 10.64-.32-.46 1.69 35.77 292.49z"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffceb4",
  d: "M619.88 487.03l-36.33 290.56-6.8 1.54-5.3 1.21.27-53.65 31.92-238.56.63-.05 15.61-1.05z"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  fill: "#f8bda5",
  d: "M576.68 778.97l.07.16-5.3 1.21.27-53.65 31.92-238.56.63-.05 6.52 1.42-34.11 289.47zM702.97 665.88l-.83 19.05-2.2 50.84-34.11-249.02 7.79-.85 2.39-.25 26.96 180.23z"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffceb4",
  d: "M702.97 665.88l-.83 19.05-28.06-196.8-.46-2.23 2.39-.25 26.96 180.23z"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  fill: "#f8bda5",
  d: "M712.33 576.45l.82 121.34-4.6-.17-9.71-.38 3.86-212.41 7.4.92 3.6.45-1.37 90.25z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffceb4",
  d: "M712.33 576.45l.82 121.34-4.6-.17 1.55-211.87 3.6.45-1.37 90.25z"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  fill: "#f8bda5",
  d: "M397.28 484l.55-8.25 47.32.27 142.26-2.2 109.78 6.05 69.89 1.38.83 7.7-179.68 3.31L397.28 484z"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffceb4",
  d: "M397.83 475.75l140.32 6.05 228.93-.55-171.14-10.46-198.11 4.96z"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M360.4 300.75l-.07.18a156.68 156.68 0 0 0-9.3 25.59l-.3 1.17a42.15 42.15 0 0 1-11.79 1.68c-10.62 0-15.41-11.14-22.84-17.61-2.92-2.53-10.42 1.77-12.55-1.47a5.21 5.21 0 0 1-.36-.55c.12-.18.25-.37.36-.55 6.58-10.26 11.18-18.9 11.18-18.9s69.34-41.82 45.67 10.46z",
  opacity: 0.1
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M381.32 285.89a42.37 42.37 0 1 1-4.41-18.82 42.41 42.41 0 0 1 4.41 18.82z",
  fill: "#ffccd0"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M356 361.83s-100.7-16.5-84.2-19.26c2.66-.44 5.56-2.09 8.58-4.54a7.16 7.16 0 0 1 1.33 2.34l18.71-2.2s23.85-5.14 33.38.74a75.12 75.12 0 0 0 14.87 6.77c.67 13.12 7.33 16.15 7.33 16.15zM422.2 528.37a5.64 5.64 0 0 1-1.81.94c-4.77 1.47-10.65 23.48-10.65 23.48s-61.12 58.68-83.85 56.42a10 10 0 0 1-1.26-4.69c-.73-15 88.05-81.45 88.05-81.45s4.34 2.26 9.52 5.3z",
  opacity: 0.1
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M583.04 466.62c0 5.57-9.74 11.14-21.76 11.14s-21.72-5.57-21.72-11.14 9.74-9 21.75-9 21.73 3.43 21.73 9z",
  fill: "#e8eaf2"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M583.04 466.62c0 5.57-9.74 11.14-21.76 11.14s-21.72-5.57-21.72-11.14 9.74-9 21.75-9 21.73 3.43 21.73 9z",
  opacity: 0.1
});

var _ref94 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 561.29,
  cy: 466.62,
  rx: 21.75,
  ry: 10.08,
  fill: "#e8eaf2"
});

var _ref95 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 561.35,
  cy: 467,
  rx: 12.98,
  ry: 5.23,
  opacity: 0.05
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M591.4 454.86c-.44-2.74-4.05-4.54-8.68-4.64a19.45 19.45 0 0 0-3.67.26c-6.26 1-10.89 4.6-10.34 8 .43 2.7 4 4.5 8.53 4.63a20 20 0 0 0 3.81-.25c6.27-.98 10.9-4.58 10.35-8zm-10.63 6.27a13.74 13.74 0 0 1-2 .18c-3.62.1-6.53-1.23-6.87-3.32-.39-2.46 2.93-5 7.42-5.76a14.28 14.28 0 0 1 3.23-.16c3 .21 5.32 1.46 5.61 3.3.4 2.46-2.9 5.04-7.39 5.76zM571.74 466.11a2.31 2.31 0 0 1-.53 1.43c-1.36 1.79-5.18 3.08-9.69 3.08-4.2 0-7.81-1.11-9.39-2.71a2.59 2.59 0 0 1-.84-1.8c0-2.5 4.58-4.52 10.23-4.52s10.22 2.02 10.22 4.52z",
  fill: "#f1cec8"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M571.74 466.11a2.31 2.31 0 0 1-.53 1.43 19.63 19.63 0 0 1-8.7 2h-2.45a19.78 19.78 0 0 1-7.93-1.65 2.59 2.59 0 0 1-.84-1.8c0-2.5 4.58-4.52 10.23-4.52s10.22 2.04 10.22 4.54zM582.72 450.22c0 .62-.07 1.24-.15 1.85a14.28 14.28 0 0 0-3.23.16c-4.49.73-7.81 3.3-7.42 5.76.34 2.09 3.25 3.42 6.87 3.32a20.81 20.81 0 0 1-1.55 1.83c-4.56-.13-8.1-1.93-8.53-4.63-.55-3.43 4.08-7 10.34-8a19.45 19.45 0 0 1 3.67-.29z",
  opacity: 0.1
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M540.3 446.65v2.82a19.76 19.76 0 0 0 19.76 19.76h2.5a19.76 19.76 0 0 0 19.71-19.76v-2.82z",
  fill: "#f1cec8"
});

var _ref99 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 561.19,
  cy: 446.03,
  rx: 21.09,
  ry: 6,
  fill: "#f6e2df"
});

var _ref100 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 561.29,
  cy: 445.65,
  rx: 19.99,
  ry: 5.42,
  opacity: 0.1
});

var _ref101 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 561.35,
  cy: 445.45,
  rx: 19.53,
  ry: 5.42,
  fill: "#fdf9f9"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M547.07 446.89a.55.55 0 1 1 .55-.54.55.55 0 0 1-.55.54zm0-.89a.35.35 0 0 0-.35.35.35.35 0 1 0 .7 0 .35.35 0 0 0-.35-.35zM547.71 445.74a.55.55 0 1 1 .54-.55.55.55 0 0 1-.54.55zm0-.9a.35.35 0 1 0 .34.35.35.35 0 0 0-.34-.35zM547.07 443.99a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.35zM551.11 448.07a.55.55 0 1 1 .54-.55.55.55 0 0 1-.54.55zm0-.9a.34.34 0 0 0-.35.35.35.35 0 1 0 .69 0 .34.34 0 0 0-.34-.35zM567.3 446.99a.55.55 0 1 1 0-1.1.55.55 0 0 1 0 1.1zm0-.9a.35.35 0 1 0 0 .7.35.35 0 1 0 0-.7zM570.9 448.41a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 0 0-.35.35.35.35 0 0 0 .7 0 .35.35 0 0 0-.35-.39zM571.02 446.09a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.35zM572.72 442.39a.55.55 0 1 1 .55-.55.54.54 0 0 1-.55.55zm0-.9a.35.35 0 0 0-.34.35.35.35 0 1 0 .69 0 .35.35 0 0 0-.35-.37zM571.89 447.47a.55.55 0 1 1 .55-.54.55.55 0 0 1-.55.54zm0-.89a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.38zM573.89 446.35a.55.55 0 1 1 .54-.55.55.55 0 0 1-.54.55zm0-.9a.35.35 0 1 0 .34.35.35.35 0 0 0-.34-.33zM573.69 447.64a.55.55 0 1 1 .54-.55.54.54 0 0 1-.54.55zm0-.89a.35.35 0 1 0 0 .69.35.35 0 1 0 0-.69zM573.07 444.34a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.32zM576.07 443.64a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.35zM567.3 442.32a.55.55 0 1 1 0-1.1.55.55 0 0 1 0 1.1zm0-.9a.35.35 0 1 0 0 .7.35.35 0 1 0 0-.7zM565.22 441.47a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.89a.35.35 0 1 0 .35.34.35.35 0 0 0-.35-.39zM560.64 441.77a.55.55 0 1 1 .54-.55.55.55 0 0 1-.54.55zm0-.9a.35.35 0 1 0 .34.35.35.35 0 0 0-.34-.35zM564.56 447.17a.55.55 0 1 1 .54-.55.55.55 0 0 1-.54.55zm0-.9a.35.35 0 1 0 0 .7.35.35 0 0 0 0-.7zM549.69 447.72a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.35zM552 446.47a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.38zM553.97 447.09a.55.55 0 1 1 .55-.54.55.55 0 0 1-.55.54zm0-.89a.35.35 0 0 0-.35.35.35.35 0 0 0 .7 0 .35.35 0 0 0-.35-.35zM554.32 445.72a.55.55 0 1 1 .55-.54.55.55 0 0 1-.55.54zm0-.89a.35.35 0 0 0-.35.35.35.35 0 1 0 .7 0 .35.35 0 0 0-.35-.35zM554.33 444.47a.55.55 0 1 1 .55-.54.55.55 0 0 1-.55.54zm0-.89a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.32zM554.88 448.85a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.35zM560.35 448.98a.55.55 0 1 1 .54-.55.55.55 0 0 1-.54.55zm0-.9a.35.35 0 1 0 .34.35.35.35 0 0 0-.34-.35zM559.66 447.64a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.89a.35.35 0 1 0 .35.34.35.35 0 0 0-.35-.34zM556.91 446.99a.55.55 0 1 1 .54-.55.55.55 0 0 1-.54.55zm0-.9a.35.35 0 1 0 0 .7.35.35 0 1 0 0-.7zM562.78 444.83a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.35zM560.29 446.35a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.33zM563.19 443.25a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.35zM562.98 441.76a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.35zM561.83 443.29a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.35zM559.01 445.87a.55.55 0 1 1 .55-.54.54.54 0 0 1-.55.54zm0-.89a.35.35 0 1 0 0 .69.35.35 0 1 0 0-.69zM556.91 445.47a.55.55 0 1 1 .54-.55.54.54 0 0 1-.54.55zm0-.89a.35.35 0 1 0 0 .69.35.35 0 1 0 0-.69zM559.66 442.9a.55.55 0 1 1 .55-.55.55.55 0 0 1-.55.55zm0-.9a.35.35 0 1 0 .35.35.35.35 0 0 0-.35-.35zM555.62 443.47a.35.35 0 1 1 .35-.35.35.35 0 0 1-.35.35zm0-.57a.22.22 0 1 0 0 .44.22.22 0 1 0 0-.44zM556.68 444.14a.35.35 0 1 1 .35-.35.35.35 0 0 1-.35.35zm0-.57a.22.22 0 0 0 0 .44.22.22 0 1 0 0-.44zM561.88 441.34a.35.35 0 1 1 .35-.35.35.35 0 0 1-.35.35zm0-.57a.22.22 0 1 0 .22.22.22.22 0 0 0-.22-.22zM562.64 447.19a.35.35 0 1 1 .35-.35.35.35 0 0 1-.35.35zm0-.57a.22.22 0 0 0 0 .44.22.22 0 1 0 0-.44zM563.56 447.6a.35.35 0 1 1 .35-.35.35.35 0 0 1-.35.35zm0-.57a.22.22 0 0 0-.22.22.22.22 0 1 0 .44 0 .22.22 0 0 0-.22-.22zM562.44 446.22a.35.35 0 0 1-.35-.35.35.35 0 1 1 .7 0 .35.35 0 0 1-.35.35zm0-.57a.22.22 0 0 0-.22.22.22.22 0 1 0 .44 0 .22.22 0 0 0-.22-.22zM569.27 442.97a.35.35 0 1 1 .35-.34.35.35 0 0 1-.35.34zm0-.57a.22.22 0 0 0-.22.23.22.22 0 1 0 .44 0 .22.22 0 0 0-.22-.23zM569.7 443.86a.35.35 0 1 1 .34-.35.35.35 0 0 1-.34.35zm0-.57a.22.22 0 1 0 0 .44.22.22 0 1 0 0-.44zM569.35 444.69a.35.35 0 0 1-.35-.35.34.34 0 0 1 .35-.35.35.35 0 0 1 .35.35.35.35 0 0 1-.35.35zm0-.57a.21.21 0 0 0-.22.22.22.22 0 0 0 .22.22.22.22 0 0 0 .22-.22.22.22 0 0 0-.22-.22zM568.44 447.24a.35.35 0 1 1 .35-.34.35.35 0 0 1-.35.34zm0-.57a.22.22 0 0 0-.22.23.22.22 0 1 0 .44 0 .22.22 0 0 0-.22-.23zM573.97 444.85a.35.35 0 0 1-.35-.35.35.35 0 1 1 .7 0 .35.35 0 0 1-.35.35zm0-.57a.22.22 0 0 0-.22.22.22.22 0 1 0 .44 0 .22.22 0 0 0-.22-.22zM565.77 446.97a.35.35 0 1 1 .35-.35.35.35 0 0 1-.35.35zm0-.57a.22.22 0 1 0 .22.22.22.22 0 0 0-.22-.22zM568.66 445.54a.35.35 0 1 1 .35-.35.35.35 0 0 1-.35.35zm0-.57a.22.22 0 0 0 0 .44.22.22 0 1 0 0-.44zM567.5 447.95a.35.35 0 0 1-.35-.35.35.35 0 1 1 .7 0 .35.35 0 0 1-.35.35zm0-.57a.22.22 0 0 0-.22.22.22.22 0 1 0 .44 0 .22.22 0 0 0-.22-.22zM575.12 445.53a.35.35 0 0 1-.35-.35.35.35 0 1 1 .69 0 .35.35 0 0 1-.34.35zm0-.58a.23.23 0 1 0 0 .45.22.22 0 0 0 .22-.22.22.22 0 0 0-.22-.23zM570.68 441.77a.35.35 0 1 1 .34-.35.35.35 0 0 1-.34.35zm0-.57a.22.22 0 1 0 0 .44.22.22 0 1 0 0-.44zM558.88 441.34a.35.35 0 1 1 .35-.35.35.35 0 0 1-.35.35zm0-.57a.22.22 0 1 0 .22.22.22.22 0 0 0-.22-.22zM548.94 444.28a.35.35 0 0 1-.35-.35.35.35 0 1 1 .7 0 .35.35 0 0 1-.35.35zm0-.57a.22.22 0 0 0-.22.22.22.22 0 0 0 .44 0 .22.22 0 0 0-.22-.22zM557.61 441.77a.35.35 0 1 1 .35-.35.35.35 0 0 1-.35.35zm0-.57a.22.22 0 1 0 0 .44.22.22 0 1 0 0-.44zM549.85 445.89a.35.35 0 1 1 .35-.35.35.35 0 0 1-.35.35zm0-.57a.22.22 0 1 0 0 .44.22.22 0 1 0 0-.44zM551.11 443.79a.35.35 0 1 1 .34-.35.35.35 0 0 1-.34.35zm0-.57a.22.22 0 1 0 0 .44.22.22 0 1 0 0-.44zM544.79 445.23a.35.35 0 1 1 .35-.35.35.35 0 0 1-.35.35zm0-.57a.22.22 0 0 0-.22.22.22.22 0 1 0 .44 0 .22.22 0 0 0-.22-.22zM553.62 448.3a.35.35 0 0 1 0-.7.35.35 0 1 1 0 .7zm0-.57a.22.22 0 1 0 0 .44.22.22 0 1 0 0-.44zM556.14 448.47a.35.35 0 1 1 0-.7.35.35 0 0 1 0 .7zm0-.57a.22.22 0 1 0 0 .44.22.22 0 0 0 0-.44z",
  fill: "#42312e",
  opacity: 0.3
});

var _ref103 = /*#__PURE__*/React.createElement("circle", {
  cx: 545.89,
  cy: 446.25,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref104 = /*#__PURE__*/React.createElement("circle", {
  cx: 547.9,
  cy: 442.39,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref105 = /*#__PURE__*/React.createElement("circle", {
  cx: 550.67,
  cy: 444.14,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref106 = /*#__PURE__*/React.createElement("circle", {
  cx: 548.87,
  cy: 441.64,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref107 = /*#__PURE__*/React.createElement("circle", {
  cx: 558.99,
  cy: 443.51,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref108 = /*#__PURE__*/React.createElement("circle", {
  cx: 550.24,
  cy: 443.09,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref109 = /*#__PURE__*/React.createElement("circle", {
  cx: 549.22,
  cy: 442.97,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref110 = /*#__PURE__*/React.createElement("circle", {
  cx: 551.22,
  cy: 445.05,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref111 = /*#__PURE__*/React.createElement("circle", {
  cx: 566.42,
  cy: 443.44,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref112 = /*#__PURE__*/React.createElement("circle", {
  cx: 570.48,
  cy: 444.23,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref113 = /*#__PURE__*/React.createElement("circle", {
  cx: 569.35,
  cy: 447.72,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref114 = /*#__PURE__*/React.createElement("circle", {
  cx: 570.9,
  cy: 446.55,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref115 = /*#__PURE__*/React.createElement("circle", {
  cx: 566.34,
  cy: 447.99,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref116 = /*#__PURE__*/React.createElement("circle", {
  cx: 565.32,
  cy: 443.41,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref117 = /*#__PURE__*/React.createElement("circle", {
  cx: 561.94,
  cy: 447.38,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref118 = /*#__PURE__*/React.createElement("circle", {
  cx: 568.05,
  cy: 444.34,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref119 = /*#__PURE__*/React.createElement("circle", {
  cx: 565.08,
  cy: 448.26,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref120 = /*#__PURE__*/React.createElement("circle", {
  cx: 552.83,
  cy: 447.72,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref121 = /*#__PURE__*/React.createElement("circle", {
  cx: 569.7,
  cy: 445.25,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref122 = /*#__PURE__*/React.createElement("circle", {
  cx: 576.07,
  cy: 444.78,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref123 = /*#__PURE__*/React.createElement("circle", {
  cx: 574.24,
  cy: 443.17,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref124 = /*#__PURE__*/React.createElement("circle", {
  cx: 567.85,
  cy: 442.74,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref125 = /*#__PURE__*/React.createElement("circle", {
  cx: 555.62,
  cy: 445.25,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref126 = /*#__PURE__*/React.createElement("circle", {
  cx: 572.44,
  cy: 444.68,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref127 = /*#__PURE__*/React.createElement("circle", {
  cx: 566.54,
  cy: 442.43,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref128 = /*#__PURE__*/React.createElement("circle", {
  cx: 571.57,
  cy: 443.38,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref129 = /*#__PURE__*/React.createElement("circle", {
  cx: 568.53,
  cy: 441.34,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref130 = /*#__PURE__*/React.createElement("circle", {
  cx: 566.34,
  cy: 440.99,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref131 = /*#__PURE__*/React.createElement("circle", {
  cx: 556.34,
  cy: 441.97,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref132 = /*#__PURE__*/React.createElement("circle", {
  cx: 558.54,
  cy: 442.23,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref133 = /*#__PURE__*/React.createElement("circle", {
  cx: 552.98,
  cy: 444.23,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref134 = /*#__PURE__*/React.createElement("circle", {
  cx: 564.18,
  cy: 444.34,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref135 = /*#__PURE__*/React.createElement("circle", {
  cx: 565.47,
  cy: 444.64,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref136 = /*#__PURE__*/React.createElement("circle", {
  cx: 558.09,
  cy: 444.99,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref137 = /*#__PURE__*/React.createElement("circle", {
  cx: 561.35,
  cy: 445.34,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref138 = /*#__PURE__*/React.createElement("circle", {
  cx: 557.84,
  cy: 442.85,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref139 = /*#__PURE__*/React.createElement("circle", {
  cx: 565.22,
  cy: 445.34,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref140 = /*#__PURE__*/React.createElement("circle", {
  cx: 564.11,
  cy: 445.54,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref141 = /*#__PURE__*/React.createElement("circle", {
  cx: 547.07,
  cy: 442.43,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref142 = /*#__PURE__*/React.createElement("circle", {
  cx: 553.82,
  cy: 443.17,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref143 = /*#__PURE__*/React.createElement("circle", {
  cx: 551.49,
  cy: 441.64,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref144 = /*#__PURE__*/React.createElement("circle", {
  cx: 550.56,
  cy: 445.32,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref145 = /*#__PURE__*/React.createElement("circle", {
  cx: 551.66,
  cy: 442.87,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref146 = /*#__PURE__*/React.createElement("circle", {
  cx: 545.25,
  cy: 443.71,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref147 = /*#__PURE__*/React.createElement("circle", {
  cx: 573.01,
  cy: 442.87,
  r: 0.2,
  fill: "#42312e",
  opacity: 0.3
});

var _ref148 = /*#__PURE__*/React.createElement("circle", {
  cx: 575.31,
  cy: 442.54,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref149 = /*#__PURE__*/React.createElement("circle", {
  cx: 577.24,
  cy: 445.45,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref150 = /*#__PURE__*/React.createElement("circle", {
  cx: 575.8,
  cy: 443.99,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref151 = /*#__PURE__*/React.createElement("circle", {
  cx: 576.42,
  cy: 445.89,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref152 = /*#__PURE__*/React.createElement("circle", {
  cx: 577.24,
  cy: 444.41,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref153 = /*#__PURE__*/React.createElement("circle", {
  cx: 575.03,
  cy: 444.14,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref154 = /*#__PURE__*/React.createElement("circle", {
  cx: 578.11,
  cy: 444.14,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref155 = /*#__PURE__*/React.createElement("circle", {
  cx: 552.35,
  cy: 443.57,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref156 = /*#__PURE__*/React.createElement("circle", {
  cx: 556.23,
  cy: 440.91,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref157 = /*#__PURE__*/React.createElement("circle", {
  cx: 560.99,
  cy: 446.67,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref158 = /*#__PURE__*/React.createElement("circle", {
  cx: 555,
  cy: 440.87,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref159 = /*#__PURE__*/React.createElement("circle", {
  cx: 553.33,
  cy: 441.1,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref160 = /*#__PURE__*/React.createElement("circle", {
  cx: 560.68,
  cy: 442.62,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref161 = /*#__PURE__*/React.createElement("circle", {
  cx: 545.98,
  cy: 444.5,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref162 = /*#__PURE__*/React.createElement("circle", {
  cx: 548.4,
  cy: 446.97,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref163 = /*#__PURE__*/React.createElement("circle", {
  cx: 557.62,
  cy: 448.18,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref164 = /*#__PURE__*/React.createElement("circle", {
  cx: 555.51,
  cy: 446.97,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref165 = /*#__PURE__*/React.createElement("circle", {
  cx: 561.88,
  cy: 448.45,
  r: 0.27,
  fill: "#42312e",
  opacity: 0.3
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M554.56 441.73s-10.93.53-5.78 4 19.93 1.53 19.93 1.53 8.17-2.06 2.92-4.49-13.19-.89-13.19-.89-9.06 1.66-2.09 3.12c0 0 8.4.76 8.77-.93s-4.72-.5-4.72-.5 2.69.6.83.9-4-.2-4-.73 2.76-.93 3.56-.9 5-.66 6.56 1.2a.69.69 0 0 1-.25 1.09c-1.48.63-5.31 1.82-11.43.88-8.03-1.23-1.11-4.28-1.11-4.28z",
  opacity: 0.1
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  d: "M300.42 339.27s23.85-5.13 33.39.74a78.51 78.51 0 0 0 20.54 8.46s17.61 4.41 23.48 10.64 11.37 2.2 13.94 10.28 10.27 15.77 10.27 15.77l-3.67 54.66 2.94 31.56s1.47 13.2-2.2 16.14.73 7.7 4 10.27 11.74 12.47 10.64 16.14 8.81 7.71 8.81 7.71.36 6.23-4.4 7.7-10.6 23.45-10.6 23.45-64.22 61.68-85.49 56.13-37.06-25.31-37.06-25.31-14.31-64.2-18.34-74.48-14.68-44-14.68-44-5.87-38.89-8.8-46.59-2.94-48.06 5.87-56.5 16.5-13.23 16.5-16.16 8.44-8.81 11.74-8.44 4.4 4 4.4 4z",
  fill: "#ff748e"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  d: "M564.2 462.54c-10.28 18-49.16 14.31-49.16 14.31s-13.57-2.94-22 1.84-48.07 9.9-48.07 9.9-15-3.3-18.71-8.08c-3.19-4.15-33.6-22.19-41.45-26.8l-1.56-.92a2.08 2.08 0 0 1-.25-.15l.06-.07 32.59-41 5.33 5.7 26.21 28s25.69 1.1 33 5.51 30.46-1.47 30.46-1.47 11.37 0 12.1-2.56 51.72-2.18 41.45 15.79z",
  fill: "#ffccd0"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  d: "M376.91 267.07a9.48 9.48 0 0 0-5 3.18c-1.93 2.62-1.68 6.2-2.42 9.37-1.22 5.18-5.27 9.86-4.5 15.12.28 1.85 1.09 3.92 0 5.43-1 1.35-3.06 1.35-4.63.76h-.12c-4.07-1.64-6.3-5.87-9.19-9.17s-8.11-5.74-11.46-2.92c-2.81 2.37-2.31 6.72-2.05 10.4s-.76 8.38-4.38 9c-1.45.27-3-.26-4.41.07-4.55 1.06-4.19 8.92-8.62 10.36-1.55.49-3.24 0-4.83-.39a16 16 0 0 0-4.1-.36c-4.66.09-9.53 1.5-13.67.32 2.15-3 4.19-6.09 6.05-9a42.37 42.37 0 1 1 73.36-42.12z",
  opacity: 0.1
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  d: "M315.27 317.15c1.6.38 3.27.88 4.83.38 4.44-1.43 4.08-9.3 8.61-10.35 1.44-.34 3 .19 4.42-.06 3.62-.65 4.65-5.36 4.38-9s-.76-8 2.05-10.39c3.35-2.82 8.57-.36 11.46 2.92s5.12 7.54 9.18 9.17c1.6.65 3.73.67 4.76-.72s.29-3.57 0-5.42c-.77-5.27 3.28-9.94 4.5-15.13.74-3.17.49-6.74 2.42-9.36 4.08-5.52 14.57-2.73 18-8.68a9.4 9.4 0 0 0 4.54-.58c1.38-.69 2.41-2.34 1.85-3.78-.43-1.11-1.6-1.71-2.59-2.38a11.76 11.76 0 0 1-5.1-10.08c.08-1.9.63-3.78.51-5.67a8.33 8.33 0 0 0-8.37-7.51c-1.25.05-2.47.4-3.72.43-5.95.18-10.93-6.52-16.72-5.17-1.24.29-2.42.95-3.69.95-2.92 0-4.73-3.35-7.52-4.23-2.22-.7-4.63.28-6.94 0s-4.12-1.57-6.07-2.64c-4.19-2.28-9.78-3.28-13.44-.24a12 12 0 0 1-2.61 2.09 7.49 7.49 0 0 1-3.8.23 35.32 35.32 0 0 0-11.32.76 4.25 4.25 0 0 0-2.59 1.35 7.29 7.29 0 0 0-.82 2.63c-1.12 4.33-6.47 5.8-10.92 6.17a6.12 6.12 0 0 0-3.3.89c-1.61 1.21-1.56 3.68-.85 5.56s1.92 3.62 2.18 5.62c.65 5-4.77 8.83-5.68 13.82-1.24 6.89 6.4 13.66 3.8 20.17-1.15 2.89-4.22 5.12-4.08 8.22s3.15 4.9 5 7.27 2.5 5.15 3.2 7.94c1.13 4.5 1.28 13.18 6.53 14.76 5.42 1.61 12.07-1.31 17.91.06z",
  fill: "#ffedba"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  d: "M316.93 464.74c6.24 8.07 28.25 27.15 42.92 31.92s-42.92-31.92-42.92-31.92zM320.23 505.1c2.57 1.83 14.31 23.84 26.78 25.68s-26.78-25.68-26.78-25.68zM323.17 486.02c.73 1.1 29.71 26.41 40.35 28.62s1.47-8.81-11.74-13.95-28.61-14.67-28.61-14.67zM323.17 539.95s19.44 7 32.65 5.14-32.65-5.14-32.65-5.14zM345.91 582.14s19.08-13.94 28.65-14.67-28.65 14.67-28.65 14.67zM260.06 357.25s46.23 5.13 33.39 7.34-33.39-7.34-33.39-7.34zM259.7 381.1s22 0 30.08-3.67-30.08 3.67-30.08 3.67zM252.73 427.32c4-1.1 20.91-36.32 27.51-26.78s-27.51 26.78-27.51 26.78zM319.5 418.15s5.87 5.5 24.21 10.64-24.21-10.64-24.21-10.64zM428.09 543.25s10.27 5.5 2.57 17.24-2.57-17.24-2.57-17.24z",
  opacity: 0.1
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  d: "M320.56 590.21l-.13-1.56c.45-5.18.13 1.56.13 1.56z",
  fill: "#e4aab4"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  d: "M327.56 620.66l-29.35-2.93-5.5-11-30.47-167.4-.71-3.93 46.58.37.43 5.32 11.92 147.56c-.06.75-.13 1.73-.23 3-.74 10.3 7.33 29.01 7.33 29.01z",
  fill: "#e4aab4"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  d: "M893.05 375.39l-.82.58c-3.13 2.13-7.33-5.48-11-4.41-3.15.9-5.75 10.64-9.18 10.64a35.81 35.81 0 0 1-15.27-3.41c-.53-1.06-1-2.06-1.55-3-1.91-3.54-3.35-5.73-3.35-5.73s5.19-.86 11.74-1.78c3-.44 6.38-.88 9.62-1.27 1.7-.21 3.36-.38 4.93-.55 6.42-.63 11.47-.78 11.47.3s1 3.67 2.62 7c.22.53.51 1.08.79 1.63z",
  opacity: 0.1
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  d: "M907.96 344.04a36 36 0 1 1-36-35.95 35.91 35.91 0 0 1 36 35.95z",
  fill: "#ffc1c7"
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  d: "M901.35 412.74l-10.73 1.1s1.1-9.63 5.78-12.66c3.1-2 8.89-5.12 12.42-7a14 14 0 0 0 3.88 1.25c-16.49 10.6-11.35 17.31-11.35 17.31z",
  fill: "#fff"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  d: "M781.02 459.24l-2.57-.37s-11.19.74-22.19 2-26.6 4.59-15.23 17.79 21.83-2.38 21.83-2.38 10.64 13.21 18.89 8.8-.73-25.84-.73-25.84zM735.71 669.64s7 16.87 6.42 21.64 23.3-4.58 23.3-4.58-5.51-12.84-2.57-15.59-27.15-1.47-27.15-1.47zM702.7 715.13h18.99v24.21H702.7z",
  fill: "#ffc1c7"
});

var _ref178 = /*#__PURE__*/React.createElement("path", {
  d: "M739.93 662.85c-1.89 3-3.25 8.15-4.21 13.44a134 134 0 0 0-2 18.84c0 3.68 1.82 2.94 0 8.81a85 85 0 0 0-3.58 14.07c0 .2-.07.4-.1.61-1.1 6.6-2.2 8.8-2.2 8.8s-27.88-1.83-33.74-5.87 2.2-8.07 2.2-8.07v-1c.59-11.21 6.31-119.28 8.75-130.76a14.63 14.63 0 0 1 3.57-6.64c3.37-3.77 8.37-6.6 12.58-8.48a59.79 59.79 0 0 1 7.69-2.85s1.46 8.47 3.37 20.48c4.37 27.45 10.99 73.24 7.67 78.62z",
  fill: "#575988"
});

var _ref179 = /*#__PURE__*/React.createElement("path", {
  d: "M732.29 584.28c-2.15 3.93-4.34 6.39-5.93 4.47-2.73-3.3-11.47-9.44-17.71-13.62 6.8-7.62 20.27-11.33 20.27-11.33s1.46 8.47 3.37 20.48z",
  fill: "#ffc1c7"
});

var _ref180 = /*#__PURE__*/React.createElement("path", {
  d: "M896.36 554.71c-.27 4.08-.76 9-1.61 15a45.94 45.94 0 0 1-25 34.86s-67.5 0-79.25-3.3c-5.93-1.68-11.12.32-14.79 2.69-.42.27-.81.54-1.19.82a25.73 25.73 0 0 0-4.55 4.19s-7.34-29.72-7.34-31.18 4-14.68 11.37-23.85 50.62-10.64 53.2-11c1.71-.24 17.47-7.11 27.88-11.71 5.27-2.32 9.17-4.06 9.17-4.06l17 5.4.63.19 13.58 4.32s1.76 4.05.9 17.63z",
  fill: "#575988"
});

var _ref181 = /*#__PURE__*/React.createElement("path", {
  d: "M881.91 532.7c-3.24 1.35-8.37 3.42-14.32 5.56-12.94 4.7-29.77 9.84-39.61 9-17.61-1.47-37.79 2.56-37.79 2.56a66.35 66.35 0 0 0-17.63 11.41c-9.17 8.07-1.1 10.63 2.94 20.18 1.65 3.91 1.27 13.06.24 22.5-.42.27-.81.54-1.19.82a25.73 25.73 0 0 0-4.55 4.19s-7.34-29.72-7.34-31.18 4-14.68 11.37-23.85 50.62-10.64 53.2-11c1.71-.24 17.47-7.11 27.88-11.71 5.27-2.32 9.17-4.06 9.17-4.06l17 5.4zM739.93 662.85c-1.89 3-3.25 8.15-4.21 13.44a9.23 9.23 0 0 1-2-1.33c-3.37-2.85-3.08-8.26-2.61-11.71.19-1.43.41-2.53.41-3 0-1.48 1.46-14.69-1.48-19.45s-3.66-23.48-3.66-23.48-4.66-26.84-5.13-50.71a59.79 59.79 0 0 1 7.69-2.85s1.46 8.47 3.37 20.48c4.32 27.44 10.94 73.23 7.62 78.61z",
  opacity: 0.1
});

var _ref182 = /*#__PURE__*/React.createElement("path", {
  d: "M884.48 531.14s-1.17.52-3.2 1.37c-3.2 1.33-8.54 3.5-14.79 5.75-12.94 4.7-29.78 9.84-39.61 9-17.61-1.47-37.79 2.56-37.79 2.56a66.35 66.35 0 0 0-17.61 11.38c-9.17 8.07-1.1 10.63 2.94 20.18 1.69 4 1.24 13.59.15 23.32-1.49 13.33-4.19 26.94-4.19 26.94s-1.1 3.67-.36 5.87.72 19.07.72 19.07a10 10 0 0 0-1.57 4.81 6.31 6.31 0 0 0 1.21 4c2.94 4 .74 14.68.74 14.68s-6.24 1.1-16.89-1.48-14.67.38-19.43-3.66c-3.37-2.85-3.08-8.26-2.61-11.71.19-1.43.41-2.53.41-3 0-1.48 1.46-14.69-1.48-19.45s-3.66-23.48-3.66-23.48-11.68-67.21.07-83.53a9.58 9.58 0 0 1 .66-.85c6.55-7.5 20.19-8.86 32.93-8.12a137.64 137.64 0 0 1 27.23 4.45c7.34 2.21 9.55 1.1 13.21-.37 2.61-1 2.82-6.15 2.71-9v-.81c0-.72-.1-1.18-.1-1.18l3.25-1.77 13.62-7.39z",
  fill: "#575988"
});

var _ref183 = /*#__PURE__*/React.createElement("path", {
  d: "M892.23 373.76a72.3 72.3 0 0 0 8.72 13.71 5.52 5.52 0 0 1-3.54.09c-1.2-.47-2.07-1.54-3.23-2.09-3-1.41-6.34.58-9.35-1.28-2.35-1.46-2.85-3.3-2.92-5.61v-1c0-3.21-.34-9.58-3.74-11.16a5.25 5.25 0 0 0-4.14.14 4.94 4.94 0 0 0-.79.41c-2.27 1.34-3.91 4.19-6.49 4a3.88 3.88 0 0 1-3.13-2.69 17.9 17.9 0 0 1-1.06-4.49c-.77-5.87-3-11.44-5.19-16.94-.42-1.05-1-2.26-2.18-2.36-1.82-.15-2.27 2.68-1.27 4.21s2.73 2.7 3 4.51c.42 3-4.07 4.75-6.52 3s-2.89-5.31-2.37-8.3 1.8-5.84 2-8.88-1.17-6.51-4.09-7.36c-2.55-.76-5.24.76-7.89.8a36 36 0 1 1 54.27 41.3z",
  opacity: 0.1
});

var _ref184 = /*#__PURE__*/React.createElement("path", {
  d: "M875.11 366.64c-2.72 1-4.42 4.63-7.31 4.36s-3.8-4.19-4.19-7.18c-.77-5.87-3-11.44-5.19-16.94-.42-1.05-1.05-2.26-2.18-2.36-1.82-.15-2.27 2.68-1.27 4.21s2.74 2.7 3 4.51c.43 3-4.06 4.75-6.51 3s-2.9-5.31-2.38-8.3 1.79-5.85 2-8.88-1.18-6.51-4.09-7.37-6 1.23-9 .73a5.57 5.57 0 0 1-3.85-7.66c1.29-2.5 4.61-4.5 3.75-7.17-1.08-3.33-6.76-1.87-9-4.59-1.75-2.13-.15-5.48 2.13-7s5.13-2.16 7.31-3.86c4.1-3.19 4.8-9.34 8.68-12.81 4.41-4 11.21-3.13 16.75-5.19 5.32-2 10.1-6.77 15.68-5.77 1.35.24 2.62.81 4 .94 2.83.26 5.41-1.44 8-2.51a19.05 19.05 0 0 1 15.72.73c-.52 3.58 3.2 6.75 6.81 6.61 2.61-.09 6.17-1 7.08 1.48.43 1.13-.11 2.45.29 3.6.68 2 3.46 2.14 5.26 3.28 4.1 2.6 2.19 9.67 5.74 13 1.56 1.45 3.81 1.8 5.75 2.67 6.41 2.84 8.73 10.59 10.32 17.42a8.55 8.55 0 0 1 .27 4.07c-.53 2-2.4 3.29-3.44 5.06-2.48 4.22.17 9.8-1.41 14.43s-6.79 7.26-7.51 12c-.25 1.6.08 3.25-.18 4.85-.7 4.34-5.27 6.84-9.48 8.12-1.18.35-2.52.78-3.05 1.9-.23.5-.27 1.07-.46 1.59-.47 1.23-1.76 1.91-3 2.47q-8.22 3.88-16.76 7.07c-1.58.59-3.35 1.17-4.93.56-1.2-.47-2.06-1.55-3.23-2.09-3-1.42-6.34.58-9.34-1.28-2.68-1.66-3-3.81-3-6.58.08-4.29-.47-13.94-7.78-11.12z",
  fill: "#b97482"
});

var _ref185 = /*#__PURE__*/React.createElement("path", {
  d: "M730.12 718.01c0 .2-.07.4-.1.61-1.1 6.6-2.2 8.8-2.2 8.8s-27.88-1.83-33.74-5.87 2.2-8.07 2.2-8.07v-1c9.65 2.47 26.28 6.12 33.84 5.53z",
  fill: "#575988"
});

var _ref186 = /*#__PURE__*/React.createElement("path", {
  d: "M730.12 718.01c0 .2-.07.4-.1.61-1.1 6.6-2.2 8.8-2.2 8.8s-27.88-1.83-33.74-5.87 2.2-8.07 2.2-8.07v-1c9.65 2.47 26.28 6.12 33.84 5.53z",
  opacity: 0.1
});

var _ref187 = /*#__PURE__*/React.createElement("path", {
  d: "M725.81 724.67s-32.29 2.2-33.57 1.65-1.29 17.06-1.29 17.06-7.15 14.31-8.07 17.79-8.07 12.11-8.07 12.11-10.25 7.52 4.75 10.45 31.55-.91 31.55-.91 11-19.08 11.92-18 0 10.09 0 10.09l6.42-1.65s-1.1-11.92 1.47-18.34-5.11-30.25-5.11-30.25z",
  fill: "#d3878a"
});

var _ref188 = /*#__PURE__*/React.createElement("path", {
  d: "M771.12 679s-6.24 1.1-16.89-1.48-14.67.38-19.43-3.66c-3.37-2.85-3.08-8.26-2.61-11.71 4.66-1 11.88-2.53 17.47-3.34s13.63.26 19.51 1.51a6.27 6.27 0 0 0 1.21 4c2.94 4.03.74 14.68.74 14.68z",
  opacity: 0.1
});

var _ref189 = /*#__PURE__*/React.createElement("path", {
  d: "M771.12 680.1s-6.24 1.1-16.89-1.48-14.67.38-19.43-3.66c-3.37-2.85-3.08-8.26-2.61-11.71 4.66-1 11.88-2.53 17.47-3.34s13.63.26 19.51 1.51a6.31 6.31 0 0 0 1.21 4c2.94 4.05.74 14.68.74 14.68z",
  fill: "#575988"
});

var _ref190 = /*#__PURE__*/React.createElement("path", {
  d: "M771.12 680.1s-6.24 1.1-16.89-1.48-14.67.38-19.43-3.66c-3.37-2.85-3.08-8.26-2.61-11.71 4.66-1 11.88-2.53 17.47-3.34s13.63.26 19.51 1.51a6.31 6.31 0 0 0 1.21 4c2.94 4.05.74 14.68.74 14.68z",
  opacity: 0.1
});

var _ref191 = /*#__PURE__*/React.createElement("path", {
  d: "M786.89 732.19l-10.82 2.75-3.12-12.84s-2.72 5.16-7.53 12.31c-.64.94-1.3 1.92-2 2.92-5.52 7.87-24.08 5.95-30.45 1.36a6.66 6.66 0 0 1-1.46-1.36c-4.23-5.5 2.2-10.83 5.31-13.76s1.47-22.38 1.47-22.38-1.47-8.62-.37-12.66 28.81-5.5 28.81-5.5 5.67 14.85 8.8 19.44 7 10.27 6.23 14.31 5.13 15.41 5.13 15.41z",
  fill: "#d3878a"
});

var _ref192 = /*#__PURE__*/React.createElement("path", {
  d: "M772.56 541.6c-4.73 6-35.51 1.47-45-7.77a9.58 9.58 0 0 1 .66-.85c6.55-7.5 20.19-8.86 32.93-8.12 5.83 4.19 15.17 11.96 11.41 16.74z",
  fill: "#ffc1c7"
});

var _ref193 = /*#__PURE__*/React.createElement("path", {
  d: "M742.87 546s-5.31-7.53-10.09-3.85-6.24-6.42-6.24-6.42 2.57-1.83 8.07.92 11.74 7.52 11 8.44-2.74.91-2.74.91z",
  opacity: 0.1
});

var _ref194 = /*#__PURE__*/React.createElement("path", {
  d: "M742.87 544.9s-5.32-7.52-10.09-3.85-6.24-6.42-6.24-6.42 2.57-1.83 8.07.92 11.74 7.52 11 8.44-2.74.91-2.74.91z",
  fill: "#575988"
});

var _ref195 = /*#__PURE__*/React.createElement("path", {
  d: "M842.29 546s27.15 12.47 21.09 17.47S842.29 546 842.29 546zM732.78 631.85s17.24 2 21.09 4.59a19.47 19.47 0 0 0 9.91 3.48c2.2 0-23.3-14.31-31-8.07zM753.5 621.76s-6.6 4.59.92 6.42-.92-6.42-.92-6.42zM716.63 682.85s9.73 12.1 13.21 8.8-13.21-8.8-13.21-8.8zM710.4 706.69c.73 0 3.12-.36 7.89 2.94s5.13-2.57 3.3-5-11.19 2.06-11.19 2.06zM699.39 436.4c1.65.55 11.28 3 13.21 8.81s-13.21-8.81-13.21-8.81zM308.56 441.08l-.79-.19s-28.1-6.31-45.51-1.57l-.71-3.93 46.58.37z",
  opacity: 0.1
});

var _ref196 = /*#__PURE__*/React.createElement("path", {
  d: "M283.56 428.79s70.44.37 95 48.79 30.09 140.89 30.09 140.89 4 13.21-1.84 13.57-8.44-12.1-8.44-12.1 2.21-9.17.37-13.21-24.18-116.26-24.18-116.26-2.57-35.22-66.77-50.63c0 0-75.21-16.87-55.77 25.32 0 0 1.1 5.87-2.93 4.77s-8.81-12.11-5.5-26 39.97-15.14 39.97-15.14z",
  fill: "#e4aab4"
});

var _ref197 = /*#__PURE__*/React.createElement("path", {
  d: "M420.95 417.25l-.2.17c-5 4-23.49 35.42-35.95 36.29a4.51 4.51 0 0 1-.73 0s-.29-.35-.83-.95a.93.93 0 0 0-.19-.22l32.59-41z",
  opacity: 0.1
});

var _ref198 = /*#__PURE__*/React.createElement("path", {
  d: "M384.43 378.16l16.51 7s8.07 8.07 7.71 15.41 4 1.83 4 1.83 2.94 1.1 2.94 4 8.07 5.87 2.93 9.9-24.21 36.69-36.68 36.32a251.39 251.39 0 0 0-23.85-23.84c-12.81-11-24.55-67.5 26.44-50.62z",
  opacity: 0.1
});

var _ref199 = /*#__PURE__*/React.createElement("path", {
  d: "M385.56 378.16l16.51 7s8.07 8.07 7.71 15.41 4 1.83 4 1.83 2.94 1.1 2.94 4 8.07 5.87 2.93 9.9-24.21 36.69-36.68 36.32a251.39 251.39 0 0 0-23.85-23.84c-12.84-11-24.56-67.5 26.44-50.62z",
  fill: "#ff748e"
});

var _ref200 = /*#__PURE__*/React.createElement("path", {
  d: "M844.12 439.06l-17.06 30.41-11.81 6.09c-.29-3.2-.48-5.36-.48-5.36s-7.71-18 12.11-31.55c17.37-11.91 8.22-21.56 5.71-23.74l.53-.47 4-.55zM958.02 425.64c-2.7 6-25.85 22.23-25.85 22.23a1.09 1.09 0 0 1 0 .12l-1.09-1.22 22-25.32 4 2.57zM896.36 554.71a56.11 56.11 0 0 1-9.68.28 144 144 0 0 0-20.19-16.73c-3.46-2.39-7.27-4.81-11.36-7.09-14.49-8-32.5-14.31-50.86-11.25-.41.06-.83.14-1.23.22 0 0 .45-.37 1.2-1s1.9-1.69 3.15-2.95l13.62-7.39 63.47 22.37s-1.17.52-3.2 1.37l14.21 4.51s1.73 4.08.87 17.66z",
  opacity: 0.1
});

var _ref201 = /*#__PURE__*/React.createElement("path", {
  d: "M876.04 407.88s49.16 4.77 71.54 2.2c0 0 11 8.44 9.54 13.94s-26 22.74-26 22.74-1.83 42.93-11.74 53.2-18.76 36.69-14.36 45.51-17.24 7.34-17.24 7.34-41.09-42.92-83.65-34.85c0 0 15.41-12.48 14.31-21.65s-2.57-26.05-2.57-26.05-7.7-18 12.11-31.55 5.14-24.24 5.14-24.24-.74-3.3 7.7-4.4a86.81 86.81 0 0 0 12.11-2.2s8.07-7.34 11.74-5.87 11.37 5.88 11.37 5.88z",
  fill: "#00c7fa"
});

var _ref202 = /*#__PURE__*/React.createElement("path", {
  d: "M932.17 441.47s5.87 11.55-.55 17.6a77.06 77.06 0 0 0-6.89 8.35 250.28 250.28 0 0 0-29.57 51.4c-13.55 31.58-36.91 85.26-40.4 88.1-5 4-5.32 12.29-.37 12.48s7.89-6.61 7.89-6.61 4.95-14.12 8.07-19.81 35.59-80.16 35.59-80.16 12.11-31.92 25.68-39.25c0 0 11.74-19.45 9.72-28.07s-9.17-4.03-9.17-4.03z",
  opacity: 0.1
});

var _ref203 = /*#__PURE__*/React.createElement("path", {
  d: "M932.17 440.34s5.87 11.56-.55 17.61a77.06 77.06 0 0 0-6.89 8.35 250.28 250.28 0 0 0-29.57 51.4c-13.55 31.58-36.91 85.26-40.4 88.1-5 4-5.32 12.29-.37 12.48s7.89-6.61 7.89-6.61 4.95-14.12 8.07-19.81 35.59-80.16 35.59-80.16 12.11-31.92 25.68-39.25c0 0 11.74-19.45 9.72-28.07s-9.17-4.04-9.17-4.04z",
  fill: "#e4aab4"
});

var _ref204 = /*#__PURE__*/React.createElement("path", {
  d: "M982.12 479.05c1.17 6.6 1.11 13.57-1.71 19.63 0 0-15.59.73-31.18-21.1l-9.36-22.93s-10.45-17.79-16.69-16.87-11 32.1-25.86 29.16-7-40.35 12.65-44.21l7.58-1.93a18.29 18.29 0 0 1 15.91 3.37c3.64 2.87 8.56 6.68 14.49 11 4.86 3.58 9.47 7.08 13.35 10.08a55 55 0 0 1 20.82 33.8z",
  fill: "#ffc1c7"
});

var _ref205 = /*#__PURE__*/React.createElement("path", {
  d: "M819.63 477.4s7.43 9.08 19.54 11 19-1.92 29.17 2.21-48.71-13.21-48.71-13.21zM920.89 460.34s-22.84 19.53-22 24.76 22-24.76 22-24.76z",
  opacity: 0.1
});

var _ref206 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M858.35 352.17a4.65 4.65 0 0 1-5.44.36c-2.14-1.56-2.75-4.44-2.52-7.14-.23.83-.44 1.66-.59 2.51-.52 3-.07 6.51 2.38 8.3s6.94 0 6.52-3a4 4 0 0 0-.35-1.03zM851.72 339.54a20 20 0 0 0 .79-4.19c.18-3-1.18-6.51-4.09-7.37s-6 1.24-9 .73a5.53 5.53 0 0 1-4.26-4.54 4.37 4.37 0 0 0-.32.55 5.56 5.56 0 0 0 3.84 7.66c3 .5 6.1-1.59 9-.73s4.27 4.34 4.09 7.37c0 .18-.03.35-.05.52zM838.44 317.26a3.7 3.7 0 0 0 .87-3.38c-1.08-3.33-6.77-1.87-9-4.58a3.44 3.44 0 0 1-.62-1.22c-1 1.59-1.25 3.49-.11 4.88 2.16 2.63 7.54 1.36 8.86 4.3zM928.13 370.33c-1.18.35-2.52.78-3.05 1.9-.24.5-.27 1.07-.47 1.59-.47 1.23-1.75 1.91-2.94 2.47-5.48 2.59-11.08 4.95-16.76 7.07-1.59.59-3.35 1.17-4.93.56-1.2-.47-2.07-1.55-3.23-2.09-3-1.41-6.34.58-9.34-1.28-2.69-1.66-3-3.8-3-6.57 0-4.2-.57-13.83-7.87-11-2.72 1-4.42 4.63-7.32 4.36s-3.79-4.19-4.18-7.18c-.77-5.87-3-11.44-5.19-16.94-.42-1.05-1.05-2.26-2.18-2.36-1.67-.14-2.18 2.24-1.48 3.81a1.4 1.4 0 0 1 .75-.14c1.12.1 1.75 1.31 2.17 2.36 2.21 5.5 4.43 11.07 5.19 16.94.39 3 1.19 6.9 4.19 7.18s4.6-3.32 7.31-4.36c7.31-2.82 7.87 6.81 7.88 11 0 2.77.27 4.92 3 6.58 3 1.86 6.33-.14 9.35 1.28 1.16.54 2 1.62 3.22 2.09 1.58.61 3.35 0 4.94-.56q8.52-3.18 16.75-7.07c1.19-.56 2.48-1.24 3-2.47.2-.52.23-1.09.47-1.59.52-1.12 1.86-1.55 3.05-1.9 4.2-1.28 8.78-3.78 9.47-8.12a9.7 9.7 0 0 0 .1-1.71c-1.6 3.14-5.38 5.08-8.9 6.15zM946.71 330.96a9.07 9.07 0 0 0-1.11 4.42 6.61 6.61 0 0 1 .38-.75c1-1.77 2.9-3.08 3.43-5.06a5.82 5.82 0 0 0 .08-2.24c-.79 1.27-2.01 2.33-2.78 3.63zM937.78 357.36a10.79 10.79 0 0 0-.09 1.61c1.63-3.54 5.57-6.1 6.87-9.91a10.69 10.69 0 0 0 .52-3.13c-1.75 4.19-6.6 6.91-7.3 11.43z"
}));

var _ref207 = /*#__PURE__*/React.createElement("path", {
  d: "M777.35 712.75a109 109 0 0 0-11.74 9c-4.77 4.41-16.69 8.07-16.69 8.07zM718.65 759.15s-22.56 20.18-26.23 19.82 26.23-19.82 26.23-19.82zM765.42 734.41c-.64.94-1.3 1.92-2 2.92-5.52 7.87-24.08 5.95-30.45 1.36 5.68-1.92 23.22-7.33 32.45-4.28z",
  opacity: 0.1
});

var _ref208 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M673.87 282.32a14.54 14.54 0 0 0 .59-2.29 14.54 14.54 0 0 0-.59 2.29zM604.2 306.7a8.9 8.9 0 0 1 .55-1.47c1.59-3.59-.45-6.15-2.82-8.56a13.15 13.15 0 0 1-4.18-8 21.78 21.78 0 0 1-.24-2.55 5.44 5.44 0 0 0-.51.8c-.85 1.7-.61 3.72-.35 5.6a13.07 13.07 0 0 0 4.18 8c1.81 1.84 3.42 3.77 3.37 6.18zM666.27 339.23c-1.81-.52-3.41 1.26-4.31 2.91s-1.92 3.63-3.78 3.87c-2.27.29-3.82-2.15-4.76-4.23s-1.86-4.31-1.86-6.55a7.34 7.34 0 0 1 .08-.82 14.8 14.8 0 0 0-1.18 4.67c-.07 2.29.89 4.46 1.84 6.55s2.49 4.52 4.76 4.23c1.86-.24 2.89-2.22 3.78-3.87s2.5-3.43 4.31-2.91c.81.24 1.65.92 2.38.51a1.72 1.72 0 0 0 .69-1.2 14.45 14.45 0 0 0 .33-2.62c-.7.32-1.5-.3-2.28-.54zM677.56 320.88c-2.37 1.9-5.29 3.34-6.73 6a9.48 9.48 0 0 0-1 3.72c1.46-2.59 4.32-4 6.65-5.88a19.55 19.55 0 0 0 6.94-11.77 19.5 19.5 0 0 1-5.86 7.93zM652.74 330.61a21.83 21.83 0 0 0 1-3.4c.65-3.45-.48-7-1.59-10.31-.82-2.44-2.39-5.4-5-5.1a5.64 5.64 0 0 1-1.52.18c-1.35-.22-1.64-2-1.78-3.36a15.24 15.24 0 0 0-12.44-13 3.93 3.93 0 0 0-2.18.14c-1 .43-1.48 1.46-2.34 2.06-2.79 1.93-6.34-1.77-9.74-1.49-2.88.24-4.64 3.2-5.83 5.83s-2.68 5.65-5.5 6.27a1.66 1.66 0 0 1-1.33-.16 1 1 0 0 1-.44-.82 6 6 0 0 1-.5 1.68c-.44 1-1.05 2.36-.16 3a1.7 1.7 0 0 0 1.33.15c2.82-.61 4.31-3.63 5.5-6.26s3-5.6 5.83-5.84c3.4-.28 6.95 3.42 9.74 1.49.86-.59 1.39-1.63 2.34-2.06a3.9 3.9 0 0 1 2.17-.14 15.24 15.24 0 0 1 12.54 13c.14 1.36.42 3.15 1.78 3.36a5.64 5.64 0 0 0 1.52-.18c2.56-.29 4.13 2.66 4.94 5.1 1.07 3.19 2.13 6.55 1.66 9.86z"
}));

var _ref209 = /*#__PURE__*/React.createElement("path", {
  d: "M670.99 446.04s-14 4.26-20.36 4.26-31.07-.13-31.07-.13-64.66-21.6-45.26 8 50.07 13.07 50.07 13.07l5.49 1.23c3 .69 61.49.14 63.42-2.2s-22.29-24.23-22.29-24.23z",
  fill: "#cf6f80"
});

var _ref210 = /*#__PURE__*/React.createElement("path", {
  d: "M711.2 471.98c-8.81.81-26.12 1-26.12 1s-12.93-25.59-23.93-24.77c0 0 10.18-11.55 14.3-10.18.7.23 1.13-.27 1.33-1.26 10.79 3.29 31.33 11.34 33.34 25.48.54 3.8.88 7.01 1.08 9.73z",
  opacity: 0.1
});

var _ref211 = /*#__PURE__*/React.createElement("path", {
  d: "M712.3 471.98c-8.81.81-26.12 1-26.12 1s-12.93-25.59-23.93-24.77c0 0 10.18-11.55 14.3-10.18.7.23 1.13-.27 1.34-1.26 10.78 3.29 31.32 11.34 33.33 25.48.54 3.8.88 7.01 1.08 9.73z",
  fill: "#575a89"
});

var _ref212 = /*#__PURE__*/React.createElement("path", {
  d: "M712.3 471.98c-8.81.81-26.12 1-26.12 1s-12.93-25.59-23.93-24.77c0 0 10.18-11.55 14.3-10.18.7.23 1.13-.27 1.34-1.26 10.78 3.29 31.32 11.34 33.33 25.48.54 3.8.88 7.01 1.08 9.73zM635.01 545.64s24.76-6.06 28.61-2.76-28.61 2.76-28.61 2.76zM564.02 569.3s10.45 6 11.55 11-11.55-11-11.55-11z",
  opacity: 0.1
});

var _ref213 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M388.1 240.91a11.37 11.37 0 0 0 .58 4v-1.26c.09-1.9.64-3.78.52-5.68a7.74 7.74 0 0 0-.54-2.29c-.01 1.79-.48 3.48-.56 5.23zM286.48 239.28c.49 1.28 1.2 2.49 1.68 3.77a5.62 5.62 0 0 0-.05-.91c-.24-1.91-1.37-3.59-2.08-5.39a7.21 7.21 0 0 0 .45 2.53zM396.35 256.12a2.74 2.74 0 0 0-.61-.92 3.74 3.74 0 0 1-1.8 1.94 9.48 9.48 0 0 1-4.53.59c-3.43 5.94-13.92 3.16-18 8.68-1.94 2.62-1.68 6.19-2.43 9.36-1.21 5.18-5.27 9.86-4.49 15.13.27 1.84 1.09 3.92 0 5.42s-3.15 1.36-4.75.72c-4.06-1.64-6.3-5.88-9.19-9.17s-8.1-5.75-11.45-2.93c-2.82 2.37-2.32 6.73-2 10.4s-.76 8.39-4.39 9c-1.45.26-3-.27-4.41.06-4.54 1.06-4.18 8.93-8.61 10.36-1.56.5-3.24 0-4.83-.38-5.84-1.38-12.5 1.55-17.9-.08-3-.91-4.34-4.14-5.15-7.58.76 4.31 1.89 9.18 5.7 10.33 5.4 1.63 12.06-1.29 17.9.08 1.59.38 3.27.88 4.83.38 4.43-1.43 4.07-9.3 8.61-10.36 1.44-.33 3 .2 4.41-.06 3.63-.64 4.66-5.36 4.39-9s-.77-8 2.05-10.4c3.35-2.81 8.56-.36 11.45 2.93s5.13 7.53 9.19 9.17c1.6.64 3.72.67 4.75-.72s.29-3.58 0-5.42c-.78-5.27 3.28-9.95 4.49-15.13.75-3.17.49-6.74 2.43-9.36 4.08-5.52 14.57-2.74 18-8.68a9.36 9.36 0 0 0 4.53-.59c1.33-.68 2.36-2.34 1.81-3.77zM290.36 299.56c-.7-2.79-1.44-5.66-3.21-7.93-1.38-1.78-3.43-3.29-4.42-5.21a5.3 5.3 0 0 0 0 .69c.13 3 3.15 4.9 5 7.27s2.49 5.09 3.18 7.86c-.19-.98-.35-1.89-.55-2.68zM286.75 272.53c-.29-3.71-2.71-7.51-3.85-11.34.34 3.83 2.72 7.62 3.85 11.34z"
}));

var _ref214 = /*#__PURE__*/React.createElement("path", {
  d: "M479.27 615.25s30.77-.92 23.43 2.38-28.11 3-28.11 3zM605.84 680.83s14.31-2.2 18 .18-18-.18-18-.18z",
  opacity: 0.1
});

var _ref215 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1031.83,
  cy: 694.45,
  rx: 40.86,
  ry: 5.61,
  fill: "#00c7fa",
  opacity: 0.1
});

var _ref216 = /*#__PURE__*/React.createElement("path", {
  d: "M1034.48 636.9s5.48 7.16-2.53 18-14.6 19.93-11.93 26.67c0 0 12.07-20.07 21.9-20.35s3.37-12.25-7.44-24.32z",
  fill: "#00c7fa"
});

var _ref217 = /*#__PURE__*/React.createElement("path", {
  d: "M1034.48 636.9a8.66 8.66 0 0 1 1.12 2.24c9.59 11.27 14.7 21.78 5.48 22.05-8.59.24-18.88 15.59-21.35 19.47a9.06 9.06 0 0 0 .29.88s12.07-20.07 21.9-20.35 3.37-12.22-7.44-24.29z",
  opacity: 0.1
});

var _ref218 = /*#__PURE__*/React.createElement("path", {
  d: "M1044.66 646.02c0 2.52-.28 4.57-.63 4.57s-.63-2-.63-4.57.35-1.33.7-1.33.56-1.22.56 1.33z",
  fill: "#ffd037"
});

var _ref219 = /*#__PURE__*/React.createElement("path", {
  d: "M1048.15 649.03c-2.21 1.21-4.14 1.94-4.31 1.63s1.5-1.53 3.71-2.74 1.34-.33 1.51 0 1.31-.09-.91 1.11z",
  fill: "#ffd037"
});

var _ref220 = /*#__PURE__*/React.createElement("path", {
  d: "M1005.56 636.9s-5.48 7.16 2.53 18 14.6 19.93 11.93 26.67c0 0-12.07-20.07-21.9-20.35s-3.37-12.25 7.44-24.32z",
  fill: "#00c7fa"
});

var _ref221 = /*#__PURE__*/React.createElement("path", {
  d: "M1005.56 636.9a9.06 9.06 0 0 0-1.12 2.24c-9.59 11.27-14.7 21.78-5.48 22.05 8.59.24 18.89 15.59 21.35 19.47a7 7 0 0 1-.29.88s-12.07-20.07-21.9-20.35-3.37-12.22 7.44-24.29z",
  opacity: 0.1
});

var _ref222 = /*#__PURE__*/React.createElement("path", {
  d: "M995.38 646.02c0 2.52.28 4.57.63 4.57s.64-2 .64-4.57-.36-1.33-.71-1.33-.56-1.22-.56 1.33z",
  fill: "#ffd037"
});

var _ref223 = /*#__PURE__*/React.createElement("path", {
  d: "M991.89 649.03c2.21 1.21 4.14 1.94 4.31 1.63s-1.49-1.53-3.71-2.74-1.34-.33-1.5 0-1.31-.09.9 1.11z",
  fill: "#ffd037"
});

var _ref224 = /*#__PURE__*/React.createElement("path", {
  d: "M997.13 680.61s15.3-.47 19.92-3.76 23.55-7.21 24.69-1.94 23 26.21 5.72 26.35-40.16-2.7-44.76-5.5-5.57-15.15-5.57-15.15z",
  fill: "#a8a8a8"
});

var _ref225 = /*#__PURE__*/React.createElement("path", {
  d: "M1047.77 699.47c-17.28.14-40.16-2.69-44.76-5.5-3.51-2.13-4.91-9.8-5.37-13.33h-.51s1 12.34 5.57 15.15 27.48 5.63 44.76 5.5c5 0 6.72-1.82 6.62-4.45-.69 1.56-2.6 2.55-6.31 2.63z",
  opacity: 0.2
});

var _ref226 = /*#__PURE__*/React.createElement("path", {
  d: "M698.4 475.86c0 2.81-8.83 6.12-19.72 6.12s-19.72-3.31-19.72-6.12 8.83-4.08 19.72-4.08 19.72 1.26 19.72 4.08z",
  fill: "#e8eaf2"
});

var _ref227 = /*#__PURE__*/React.createElement("path", {
  d: "M698.4 475.86c0 2.81-8.83 6.12-19.72 6.12s-19.72-3.31-19.72-6.12 8.83-4.08 19.72-4.08 19.72 1.26 19.72 4.08z",
  opacity: 0.1
});

var _ref228 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 678.68,
  cy: 475.86,
  rx: 19.72,
  ry: 5.1,
  fill: "#e8eaf2"
});

var _ref229 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 678.68,
  cy: 475.86,
  rx: 11.15,
  ry: 2.88,
  opacity: 0.1
});

var _ref230 = /*#__PURE__*/React.createElement("path", {
  d: "M694.83 469.75a8.68 8.68 0 0 1-7.12 4.51 11.13 11.13 0 0 1-3.44-.24l1.36-2a6.78 6.78 0 0 0 2.63 0 5.1 5.1 0 0 0 3.46-2.57c1.44-2.54-.36-2.91-1.62-2.89a6.89 6.89 0 0 0-.77 0l1.08-1.58s.44-.08 1.08-.13c2.07-.1 6.07.17 3.34 4.9zM686.13 476.71a24.77 24.77 0 0 1-15.23 0l.11-.76.08-.57 14.84-.19.12.91z",
  fill: "#f1cec8"
});

var _ref231 = /*#__PURE__*/React.createElement("path", {
  d: "M688.26 472.01a12.21 12.21 0 0 1-.55 2.25 11.13 11.13 0 0 1-3.44-.24l1.36-2a6.78 6.78 0 0 0 2.63-.01zM691.49 464.89a2.2 2.2 0 0 1-.42.57l-.11.11a8.74 8.74 0 0 0-.86 1 6.89 6.89 0 0 0-.77 0l1.08-1.58s.44-.05 1.08-.1zM686.05 476.1c-2.63 1-12.5 1.24-15-.15l.08-.57 14.84-.19z",
  opacity: 0.1
});

var _ref232 = /*#__PURE__*/React.createElement("path", {
  d: "M690.79 465.47l-.12.11a8.28 8.28 0 0 0-2.5 4.95c-.46 4.37-1.4 4.81-1.51 5-.76 1.32-14 1.84-16 0-1.64-1.52-3.24-4.83-2.5-6.7.39-1-.44-2.11-1.29-2.91-1.1-1-.7-2.52.88-3.21 3.75-1.66 10.41-1.74 10.41-1.74 5.68-.3 9.31.45 11.53 1.27l.28.12a2.44 2.44 0 0 1 1.3 1.27 1.69 1.69 0 0 1-.48 1.84z",
  fill: "#f1cec8"
});

var _ref233 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 678.48,
  cy: 465.04,
  rx: 10.05,
  ry: 1.63,
  opacity: 0.1
});

var _ref234 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 678.48,
  cy: 465.23,
  rx: 10.05,
  ry: 1.63,
  fill: "#42312e"
});

var _ref235 = /*#__PURE__*/React.createElement("path", {
  d: "M680.56 464.21s-7.23.16-7 1.92a23.31 23.31 0 0 1 7-1.92zM682.63 464.66s-4.31 0-3.62 1.47c0 0 1-.11.86-.49s2.76-.77 2.76-.77z",
  fill: "#fff",
  opacity: 0.2
});

var _ref236 = /*#__PURE__*/React.createElement("path", {
  d: "M667.28 464.21s-.28 3 11 2.86 11.22-2.18 11.32-2.86h-.62s-.14 2.47-10.54 2.41-10.68-2.41-10.68-2.41z",
  fill: "#f6e2df"
});

var _ref237 = /*#__PURE__*/React.createElement("path", {
  d: "M691.27 463.71l-6.8 2.49a.87.87 0 0 1-.81-.11l-.11-.1c-.32-.27-.22-.66.2-.84l6.22-2.71a2.44 2.44 0 0 1 1.3 1.27z",
  opacity: 0.1
});

var _ref238 = /*#__PURE__*/React.createElement("path", {
  d: "M683.75 465l17.64-7.67a3.54 3.54 0 0 1 1.32-.29c.89 0 2.15.1 1.74 1.07a2.14 2.14 0 0 1-1.32 1.11l-18.66 6.83a.85.85 0 0 1-.81-.11l-.11-.1c-.32-.26-.22-.66.2-.84z",
  fill: "#e8eaf2"
});

var _ref239 = /*#__PURE__*/React.createElement("path", {
  d: "M683.75 465l17.64-7.67a3.54 3.54 0 0 1 1.32-.29c.89 0 2.15.1 1.74 1.07a2.14 2.14 0 0 1-1.32 1.11l-18.66 6.83a.85.85 0 0 1-.81-.11l-.11-.1c-.32-.26-.22-.66.2-.84z",
  opacity: 0.1
});

var _ref240 = /*#__PURE__*/React.createElement("path", {
  d: "M683.75 464.9l17.64-7.67a3.75 3.75 0 0 1 1.32-.29c.89 0 2.15.1 1.74 1.07a2.18 2.18 0 0 1-1.32 1.12l-18.66 6.83a.85.85 0 0 1-.81-.12l-.11-.09c-.32-.28-.22-.66.2-.85z",
  fill: "#e8eaf2"
});

var _ref241 = /*#__PURE__*/React.createElement("path", {
  d: "M682.77 465.12s1.88-.28 1.64.06.81.78.81.78a8.09 8.09 0 0 1-2.23.12c-.29-.2-.22-.96-.22-.96z",
  opacity: 0.1
});

var _ref242 = /*#__PURE__*/React.createElement("path", {
  d: "M682.63 465.17s1.88-.28 1.64.06.81.78.81.78a8.14 8.14 0 0 1-2.24.12c-.28-.2-.21-.96-.21-.96z",
  fill: "#42312e"
});

var _ref243 = /*#__PURE__*/React.createElement("path", {
  d: "M679.68 451.74a4.64 4.64 0 0 0-1.69 2.16 5 5 0 0 0 .11 2.23 9.27 9.27 0 0 0 .38 1.51c.1.28.38.6.58.4 0-.7-.22-1.39-.18-2.08a3.88 3.88 0 0 1 .92-2.07 10.14 10.14 0 0 0 1.29-1.8c.14-.3.69-3.05-.07-2.57-.15.1-.33 1-.47 1.23a4.87 4.87 0 0 1-.87.99zM679.97 456.27c.06.25.37.45.51.68a1.19 1.19 0 0 1 .13.48 2.54 2.54 0 0 1-.51 2.28 1.83 1.83 0 0 0 1.28-1.17 3.19 3.19 0 0 0 .17-.79 6.61 6.61 0 0 0 0-.77c0-.38.17-1.37-.51-1.56a.85.85 0 0 0-1.07.85z",
  fill: "#f2dcdc"
});

var _ref244 = /*#__PURE__*/React.createElement("path", {
  d: "M668.26 468.27s.85.88 3.24 1a8.86 8.86 0 0 1-3.41-.28z",
  opacity: 0.1
});

var _ref245 = /*#__PURE__*/React.createElement("path", {
  fill: "#e4aab4",
  d: "M438.86 614.08l36.99-.11-12.11 19.32-23.85 12.09-1.03-31.3z"
});

function SvgIllustrationFlowingConversation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1125.12,
    height: 800.94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationFlowingConversation);
export default __webpack_public_path__ + "static/media/illustration-flowing-conversation.447b9b47aef8c266f047e609cbf11004.svg";
export { ForwardRef as ReactComponent };